import React from 'react';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, InputGroup, Popover, OverlayTrigger } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withChemicalDefaultRoute } from './withChemicalDefaultRoute';
import ChemEdit from '../ChemEdit';
import EditTable from '../EditTable';
import Tabs from '../Tabs';
import ADACheckbox from '../ADACheckbox';
import { Link } from 'react-router-dom';
import { LockFill, UnlockFill, HourglassSplit, Download } from 'react-bootstrap-icons';
import { encode } from 'html-entities';

class Chemical extends ChemComponent {
	constructor(props) {
		super(props);
		
		this.state = {
			editable: props.editable,
			activeTab: props.params.activeTab || 'Profile',
			chem: {
				chemical: {
					CHEM_ID: null
				},
				chem_safety: {},
				chem_formula: {},
				chem_alt_name: [],
				chem_alt_cas: [],
				chem_image_structure: [],
				chem_structure: {},
				chem_image_ms: [],
				chem_image_chemwatch: [],
				chem_safety_ghs: [],
				chem_safety_ghs_input: {},
				chem_ghs_hh_cat_h: [],
				chem_ghs_hh_cat_e: [],
				chem_ghs_hh_cat_p: [],
				toxic_release_inventory: [{},{}],
				chem_image_toxic1: [],
				chem_image_toxic2: [],
				chem_image_toxic_info: [],
				chem_image_misc_info: [],
				chem_image_stab_react: [],
				chem_i_standard_select: {},
				chem_image_canada_above: [],
				chem_image_canada_below: [],
				chem_image_europe_above: [],
				chem_image_europe_below: [],
				chem_image_japan_above: [],
				chem_image_japan_below: [],
				chem_image_other_above: [],
				chem_image_other_below: [],
				chem_i_standard_canada: {},
				chem_i_standard_europe: {},
				chem_i_standard_japan: {},
				chem_i_standard_other: {},
			},
			rtecsColumns: this.copyColumns(rtecsColumns),
			hStatementColumns: [],
			pStatementColumns: [],
			toxicColumns: [
				this.copyToxicColumns(0),
				this.copyToxicColumns(1)
			],
			organColumns: [],
			editorsOpen: [],
			renderKey: 0
		}
	}	

	componentDidMount() {
		this.loadChemical();
	}

	componentDidUpdate(prevProps) {
		var newActiveTab = this.props.params.activeTab || 'Profile';
		
		// this is necessary so browser back/forward buttons will work across tabs
		if (newActiveTab !== this.state.activeTab) {
			this.mergeState({
				activeTab: newActiveTab,
				renderKey: this.state.renderKey + 1
			});
		}
		
		// also reload the item if the item ID has changed
		if (this.props.params.chemId !== prevProps.params.chemId) {
			this.loadChemical();
		}
	}

	loadChemical(event) {
		var self = this;

		if (this.props.params.chemId) {
			this.ajax({
				type: 'post',
				url: this.getConfig().host + '/Reuse/GetChemical',
				data: { 
					__RequestVerificationToken: this.props.user.antiForgeryToken,
					chemid: this.props.params.chemId
				}
			}).done(function (data) {
				if (data.Success) {
					var i;
					var chem = data.Data;

					// convert MARINE_POL_PP from 'PP' to 'Y'
					chem.chem_safety.MARINE_POL_PP = chem.chem_safety.MARINE_POL_PP === 'PP' ? 'Y' : null;

					// transfer GHS statement IDs to chem_safety_ghs_input
					self.ghsToGHSInput(chem);

					// convert from mvc to js
					self.mvc2js(chem, chemicalColumns);
					self.mvc2js(chem, rtecsColumns);
					self.mvc2js(chem, formulaColumns);
					self.mvc2js(chem, shippingColumns);
					self.mvc2js(chem, nfpaColumns);
					self.mvc2js(chem, hmisColumns);
					self.mvc2js(chem, oshaColumns);
					self.mvc2js(chem, specialColumns);
					self.mvc2js(chem, rmpColumns);
					self.mvc2js(chem, stabReactColumns);
										
					// copy rtecs columns
					var newRTECSColumns = self.copyColumns(rtecsColumns);
					
					// create H statement columns
					var hStatementColumns = self.generateStatementColumns(chem, 4);
					
					// create P statement columns
					var pStatementColumns = self.generateStatementColumns(chem, 3);
					
					// find storage column
					var storageIdx = self.findColumnByAccessor(newRTECSColumns, 'chemical.STORAGE');
					
					// add ID to search criteria
					newRTECSColumns[storageIdx].options.search.Children.push(
						{ Attribute: 'CHEM_ID', Operator: '=', LongValue: chem.chemical.CHEM_ID });
						
					// compose modified info
					chem.chemical.MODIFIED = self.composeChangeInfo(chem.chemical.MODIF_BY, chem.chemical.MODIF_DATE);
					
					// compose updated info for each image
					for (i = 0; i < chem.chem_image_structure.length; i++) {
						chem.chem_image_structure[i].UPDATED = self.composeChangeInfo(chem.chem_image_structure[i].MODIF_BY, chem.chem_image_structure[i].MODIF_DATE);
						if (self.isEmpty(chem.chem_image_structure[i].UPDATED)) {
							chem.chem_image_structure[i].UPDATED = self.composeChangeInfo(chem.chem_image_structure[i].CREATED_BY, chem.chem_image_structure[i].CREATE_DATE);
						}
					}					

					// generate columns for TRI
					var toxicColumnsCopy = [
						self.copyToxicColumns(0, chem.toxic_release_inventory[0].TRI_SYMBOL),
						self.copyToxicColumns(1, chem.toxic_release_inventory[1].TRI_SYMBOL)
					];
					
					// generate columns for target organs
					var organColumns = self.generateOrganColumns(chem);
											
					self.mergeState({
						chem: chem,
						rtecsColumns: newRTECSColumns,
						hStatementColumns: hStatementColumns,
						pStatementColumns: pStatementColumns,
						toxicColumns: toxicColumnsCopy,
						organColumns: organColumns,
						renderKey: self.state.renderKey + 1
					}, () => {
						if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
					});
				} else {
					self.showAlert('Server Error', data.Message);
				}			
			}).fail(function (jqXHR, textStatus, errorThrown) {
				self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
			});
		} else {
			this.mergeState({ chem: { chemical: { CHEM_ID: '(new)' }}});
		}
	}
	
	generateOrganColumns(chem) {
		var colsize = 12;
		var columns = [];
		var cto_input = {};
		
		var cto = chem.chem_target_organ;
		var organs = chem.target_organ;
		
		// for each organ
		for (var o = 0; o < organs.length; o++) {
			// track if organ is selected
			var organ_selected = false;
			
			// generate an accessor
			var accessor = 'ORGAN_' + organs[o].ORGAN_ID;

			// for each chem target organ
			for (var c = 0; c < cto.length; c++) {
				// if this is the same organ
				if (organs[o].ORGAN_ID === cto[c].ORGAN_ID) {					
					// note that the organ is selected
					organ_selected = true;
					
					// exit cto loop
					break;
				}
			}
			
			// set the value in the input object
			cto_input[accessor] = organ_selected;
			
			// add a column to display the organ checkbox
			columns.push({
				Header: organs[o].ORGAN_NAME,
				accessor: 'chem_target_organ_input.' + accessor,
				type: 'checkbox',
				row: o % colsize,
				col: Math.floor(o/colsize)
			});
		}
		
		// add cto input object to chem object
		chem.chem_target_organ_input = cto_input;
		
		return columns;
	}
	
	copyToxicColumns(i, symb) {
		var toxicColumnsCopy = this.copyColumns(toxicColumns);
		var triReportIdx = this.findColumnByAccessor(toxicColumnsCopy, 'TRI_REPORT_THRESHOLD');
		toxicColumnsCopy[triReportIdx].Header = (i + 1) + '. ' + toxicColumnsCopy[triReportIdx].Header;
		if (symb !== 'c') {
			var symbolIdx = this.findColumnByAccessor(toxicColumnsCopy, 'TRI_C');
			toxicColumnsCopy.splice(symbolIdx, 1);
		}
		return toxicColumnsCopy;
	}
	
	generateStatementColumns(chem, typeCode) {
		var row;
		var col;
		var firstStmtIdx = -1;
		var ordinal;
		var columns = [];
		// 3 = P statements, 4 = H statements
		var colsize = typeCode === 3 ? 37 : 20;
		
		// for each row in ghs
		// assumption: chem_safety_ghs is ordered by type code
		for (var i = 0; i < chem.chem_safety_ghs.length; i++) {
			// if the type code matches
			if (chem.chem_safety_ghs[i].TYPE_CODE === typeCode)
			{
				if (firstStmtIdx === -1) firstStmtIdx = i;
				ordinal = i - firstStmtIdx;
				row = ordinal % colsize;
				col = Math.floor(ordinal / colsize);
				
				columns.push({
					Header: '',
					accessor: 'chem_safety_ghs_input.' + this.statementCodeToName(chem.chem_safety_ghs[i].STATEMENT_CODE),
					type: 'checkbox',
					value: chem.chem_safety_ghs[i].STATEMENT_ID,
					label: chem.chem_safety_ghs[i].STATEMENT_CODE,
					row: row,
					col: col
				});
			}
		}
		
		return columns;
	}
	
	ghsToGHSInput(chem) {
		// if there is no ghs input object, create one
		if (!chem.chem_safety_ghs_input) chem.chem_safety_ghs_input = {};
		
		// for each statement in the GHS table
		for (var i = 0; i < chem.chem_safety_ghs.length; i++) {
			var typeCodeAccessor = this.getAccessorForStatementTypeCode(chem.chem_safety_ghs[i].TYPE_CODE);
			var statementIDAccessor = this.getAccessorForStatementID(chem.chem_safety_ghs[i].STATEMENT_ID);
			
			// do types 3 & 4 first so they don't interfere with type 5 hazard_pict
			if ([3,4].includes(chem.chem_safety_ghs[i].TYPE_CODE)) {
				// store the ghs ID (statement ID) in chem_safety_ghs_input
				chem.chem_safety_ghs_input[this.statementCodeToName(chem.chem_safety_ghs[i].STATEMENT_CODE)] = chem.chem_safety_ghs[i].GHS_ID;
			} else if (!this.isEmpty(typeCodeAccessor)) {
				if (chem.chem_safety_ghs[i].GHS_ID !== null) {
					// store the ghs ID (statement ID) in chem_safety_ghs_input
					chem.chem_safety_ghs_input[typeCodeAccessor] = chem.chem_safety_ghs[i].GHS_ID;
				}
			} else if (!this.isEmpty(statementIDAccessor)) {
				if (chem.chem_safety_ghs[i].GHS_ID !== null) {
					// store the ghs ID (statement ID) in chem_safety_ghs_input
					chem.chem_safety_ghs_input[statementIDAccessor] = chem.chem_safety_ghs[i].GHS_ID;
				}
				
				// translate from checkbox to select for EUROPE_SVHC
				if (chem.chem_safety_ghs[i].TYPE_CODE === 20) {
					if (chem.chem_safety_ghs[i].GHS_ID === statementIDMap.EUROPE_SVHC_AUTH) {
						chem.chem_safety_ghs_input.EUROPE_SVHC = statementIDMap.EUROPE_SVHC_AUTH;
					} else if (chem.chem_safety_ghs[i].GHS_ID === statementIDMap.EUROPE_SVHC_CAND) {
						chem.chem_safety_ghs_input.EUROPE_SVHC = statementIDMap.EUROPE_SVHC_CAND;
					}
				}
			}
		}
	}
	
	statementCodeToName(code) {
		if (code === undefined || code === null) return code;
		return code.replace(/[^a-z0-9]/gi, '_');
	}
	
	ghsInputToGHS(chem) {
		var k;
		var g;

		// step 1: collect type codes
		var typeKeys = Object.keys(statementTypeMap);
		var typeCodes = [];
		for (k = 0; k < typeKeys.length; k++) {
			typeCodes.push(statementTypeMap[typeKeys[k]]);
		}
		
		// step 2: collect statement IDs
		var idKeys = Object.keys(statementIDMap);
		var idValues = [];
		for (k = 0; k < idKeys.length; k++) {
			idValues.push(statementIDMap[idKeys[k]]);
		}
		
		// step 3: for each ghs row
		for (g = 0; g < chem.chem_safety_ghs.length; g++) {
			if ([3,4].includes(chem.chem_safety_ghs[g].TYPE_CODE)) {
				// get the data from ghs_input
				var value = this.getByAccessor(chem, 'chem_safety_ghs_input.' +
					this.statementCodeToName(chem.chem_safety_ghs[g].STATEMENT_CODE));
				
				// if there is a value 
				if (!this.isEmpty(value)) {
					// put the value in GHS_ID
					chem.chem_safety_ghs[g].GHS_ID = value;
					
					// clear delete flag
					chem.chem_safety_ghs[g].DELETE_FLAG = null;
				} else {
					// mark for deletion
					chem.chem_safety_ghs[g].DELETE_FLAG = 'Y';
				}
			} else if (typeCodes.includes(chem.chem_safety_ghs[g].TYPE_CODE)) {
				// get the accessor
				var typeCodeAccessor = this.getAccessorForStatementTypeCode(chem.chem_safety_ghs[g].TYPE_CODE);
				
				// if the selected value is numeric and matches the statement ID
				if (this.isNumeric(chem.chem_safety_ghs_input[typeCodeAccessor]) &&
					+chem.chem_safety_ghs_input[typeCodeAccessor] === chem.chem_safety_ghs[g].STATEMENT_ID) {
					// copy the statement ID to the GHS ID
					chem.chem_safety_ghs[g].GHS_ID = chem.chem_safety_ghs[g].STATEMENT_ID;
					
					// clear delete flag
					chem.chem_safety_ghs[g].DELETE_FLAG = null;
				} else {
					// set delete flag
					chem.chem_safety_ghs[g].DELETE_FLAG = 'Y';
				}
			} else if (idValues.includes(chem.chem_safety_ghs[g].STATEMENT_ID)) {
				// get the accessor
				var statementIDAccessor = this.getAccessorForStatementID(chem.chem_safety_ghs[g].STATEMENT_ID);

				// if the checkbox was checked 
				if (chem.chem_safety_ghs_input[statementIDAccessor] === chem.chem_safety_ghs[g].STATEMENT_ID) {					
					// populate GHS_ID with STATEMENT_ID
					chem.chem_safety_ghs[g].GHS_ID = chem.chem_safety_ghs[g].STATEMENT_ID;

					// make sure delete_flag is not set
					chem.chem_safety_ghs[g].DELETE_FLAG = null;
				} else {
					// set delete flag 
					chem.chem_safety_ghs[g].DELETE_FLAG = 'Y';
				}
			}
		}
		
		// step 4: move backwards through ghs rows
		for (g = chem.chem_safety_ghs.length - 1; g >= 0; g--) {
			// if this row is marked for deletion
			if (chem.chem_safety_ghs[g].DELETE_FLAG === 'Y') {
				// remove the row
				chem.chem_safety_ghs.splice(g, 1);
			}
		}
	}
	
	getAccessorForStatementTypeCode(typeCode) {
		// get keys from statement type map
		var keys = Object.keys(statementTypeMap);
		
		// for each key in the statement type map
		for (var i = 0; i < keys.length; i++) {
			// if this key has the type code we are looking for
			if (statementTypeMap[keys[i]] === typeCode) return keys[i];
		}
		
		return null;
	}
	
	getAccessorForStatementID(statementId) {
		// get keys from statement ID map
		var keys = Object.keys(statementIDMap);
		
		// for each key in the statement ID map
		for (var i = 0; i < keys.length; i++) {
			// if this key has the statement ID we are looking for
			if (statementIDMap[keys[i]] === statementId) return keys[i];
		}
		
		return null;
	}
	
	onChange(accessor, value) {
		var chem_i_standard;
		var newState = this.copyObject(this.state);
		var intlStdAccessor = this.getIntlStdAccessor(newState.chem, accessor);
		this.setByAccessor(newState.chem, intlStdAccessor || accessor, value);
		if (accessor === 'chem_i_standard_select.STANDARD_ID') {
			// get the delete status from the requested country
			chem_i_standard = this.getChemIntlStd(newState.chem, value);
			if (!this.isEmpty(chem_i_standard)) {
				// if this standard has not been created
				if (this.isEmpty(chem_i_standard.STANDARD_ID)) {
					// leave the active flag empty so user must pick
					newState.chem.chem_i_standard_select.ACTIVE_FLAG = null;
				} else {
					// if delete flag is set
					if (chem_i_standard.DELETE_FLAG === 'Y') {
						// use 'N' for active flag to indicate the record is not active
						newState.chem.chem_i_standard_select.ACTIVE_FLAG = 'N';
					} else {
						// record exists and is active
						newState.chem.chem_i_standard_select.ACTIVE_FLAG = 'Y';
					}
				}
			}
		} else if (accessor === 'chem_i_standard_select.ACTIVE_FLAG') {
			// set delete flag 
			chem_i_standard = this.getChemIntlStd(newState.chem, this.state.chem.chem_i_standard_select.STANDARD_ID);
			if (!this.isEmpty(chem_i_standard)) {
				// delete flag is inverse of active flag
				chem_i_standard.DELETE_FLAG = value === 'Y' ? null : 'Y';
			}
		} else if (accessor === 'chem_safety_ghs_input.EUROPE_SVHC') {
			// speacial case... translate between select & checkboxes
			newState.chem.chem_safety_ghs_input.EUROPE_SVHC_AUTH = 
				(this.isNumeric(value) && +value === statementIDMap.EUROPE_SVHC_AUTH) ? statementIDMap.EUROPE_SVHC_AUTH : null;
			newState.chem.chem_safety_ghs_input.EUROPE_SVHC_CAND = 
				(this.isNumeric(value) && +value === statementIDMap.EUROPE_SVHC_CAND) ? statementIDMap.EUROPE_SVHC_CAND : null;
		}		

		newState.renderKey = this.state.renderKey + 1;

		// if this accessor represents an EditTable
		if (['chem_alt_name','chem_alt_cas','chem_image_structure','chem_image_ms','chem_image_chemwatch',
			'chem_ghs_hh_cat_h','chem_ghs_hh_cat_e','chem_ghs_hh_cat_p','chem_image_toxic1','chem_image_toxic2',
			'chem_image_toxic_info','chem_image_misc_info','chem_image_stab_react','chem_image_intl_above',
			'chem_image_intl_below'].includes(accessor)) {
			// update editor status as well
			newState.editorsOpen = this.setEditorStatus(accessor, false);
		}
		this.setState(newState);
	}
	
	getChemIntlStd(chem, standardId) {
		if (this.isNumeric(standardId)) {
			var stdIdNum = +standardId;
			if (stdIdNum === 1) {
				return chem.chem_i_standard_canada;
			} else if (stdIdNum === 2) {
				return chem.chem_i_standard_europe;
			} else if (stdIdNum === 3) {
				return chem.chem_i_standard_japan;
			} else if (stdIdNum === 10) {
				return chem.chem_i_standard_other;
			}
		}
		
		return null;
	}
	
	getIntlStdImgAbove(chem, standardId) {
		if (this.isNumeric(standardId)) {
			var stdIdNum = +standardId;
			if (stdIdNum === 1) {
				return chem.chem_image_canada_above;
			} else if (stdIdNum === 2) {
				return chem.chem_image_europe_above;
			} else if (stdIdNum === 3) {
				return chem.chem_image_japan_above;
			} else if (stdIdNum === 10) {
				return chem.chem_image_other_above;
			}
		}
		
		return null;
	}
	
	getIntlStdImgBelow(chem, standardId) {
		if (this.isNumeric(standardId)) {
			var stdIdNum = +standardId;
			if (stdIdNum === 1) {
				return chem.chem_image_canada_below;
			} else if (stdIdNum === 2) {
				return chem.chem_image_europe_below;
			} else if (stdIdNum === 3) {
				return chem.chem_image_japan_below;
			} else if (stdIdNum === 10) {
				return chem.chem_image_other_below;
			}
		}
		
		return null;
	}
	
	getIntlStdAccessor(chem, accessor) {
		var country = null;
		
		if (this.isNumeric(chem.chem_i_standard_select.STANDARD_ID)) {
			var stdIdNum = +chem.chem_i_standard_select.STANDARD_ID;
			if (stdIdNum === 1) {
				country = 'canada';
			} else if (stdIdNum === 2) {
				country = 'europe';
			} else if (stdIdNum === 3) {
				country = 'japan';
			} else if (stdIdNum === 10) {
				country = 'other';
			}
		}

		if (country) {
			if (accessor.startsWith('chem_i_standard.')) {
				return 'chem_i_standard_' + country + accessor.substring(15);
			} else if (accessor === 'chem_image_intl_above') {
				return 'chem_image_' + country + '_above';
			} else if (accessor === 'chem_image_intl_below') {
				return 'chem_image_' + country + '_below';
			}
		}
		
		return null;		
	}

	onChangeTRI(accessor, value, idx) {
		var partialState = {
			chem: {
				toxic_release_inventory: this.copyObject(this.state.chem.toxic_release_inventory)
			}
		}; 
		this.setByAccessor(partialState.chem.toxic_release_inventory[idx], accessor, value);
		if (accessor === 'TRI_SYMBOL') {
			partialState.toxicColumns = [
				this.copyToxicColumns(0, partialState.chem.toxic_release_inventory[0].TRI_SYMBOL),
				this.copyToxicColumns(1, partialState.chem.toxic_release_inventory[1].TRI_SYMBOL)
			];
		}
		this.mergeState(partialState);
	}

	onEdit(accessor, editorIsOpen, idx) {
		// adjust list of open editors in new state
		var newState = {
			editorsOpen: this.setEditorStatus(accessor, editorIsOpen),
			renderKey: this.state.renderKey + 1
		};

		this.mergeState(newState);
	}
	
	setEditorStatus(accessor, editorIsOpen) {
		var editorsOpen = this.copyObject(this.state.editorsOpen);
		if (editorIsOpen) {
			// add to list if it isn't already present
			if (!editorsOpen.includes(accessor)) editorsOpen.push(accessor);
		} else {			
			// remove from list if it is present
			if (editorsOpen.includes(accessor)) editorsOpen.splice(editorsOpen.indexOf(accessor), 1);
		}
		return editorsOpen;
	}		
		
	onSubmit(event) {
		var self = this;
		var i;
		
		// prevent user from saving if an editor is open
		if (this.state.activeTab === 'Profile' && this.state.editorsOpen.includes('chem_alt_name')) {
			this.showAlert('Editor Open', 'Please close the alternative name editor before saving.');
		} else if (this.state.activeTab === 'Profile' && this.state.editorsOpen.includes('chem_alt_cas')) {
			this.showAlert('Editor Open', 'Please close the alternative CAS number editor before saving.');
		} else if (this.state.activeTab === 'Physical\\r\\nChemical\\r\\nCharacteristics' && this.state.editorsOpen.includes('chem_image_structure')) {
			this.showAlert('Editor Open', 'Please close the structure image editor before saving.');
		} else if (this.state.activeTab === 'Physical\\r\\nChemical\\r\\nCharacteristics' && this.state.editorsOpen.includes('chem_image_ms')) {
			this.showAlert('Editor Open', 'Please close the mass spectrometry image editor before saving.');
		} else if (this.state.activeTab === 'Shipping\\r\\nInformation' && this.state.editorsOpen.includes('chem_image_chemwatch')) {
			this.showAlert('Editor Open', 'Please close the Chemwatch Hazard Rating image editor before saving.');
		} else if (this.state.activeTab === 'Hazard\\r\\nCategories' && this.state.editorsOpen.includes('chem_ghs_hh_cat_h')) {
			this.showAlert('Editor Open', 'Please close the Health Hazard editor before saving.');
		} else if (this.state.activeTab === 'Hazard\\r\\nCategories' && this.state.editorsOpen.includes('chem_ghs_hh_cat_e')) {
			this.showAlert('Editor Open', 'Please close the Environmental Hazard editor before saving.');
		} else if (this.state.activeTab === 'Hazard\\r\\nCategories' && this.state.editorsOpen.includes('chem_ghs_hh_cat_p')) {
			this.showAlert('Editor Open', 'Please close the Physical Hazard editor before saving.');
		} else if (this.state.activeTab === 'Carcinogens/\\r\\nSpec. Consid./\\r\\nTarget Organs' && this.state.editorsOpen.includes('chem_image_toxic1')) {
			this.showAlert('Editor Open', 'Please close the TRI image editor before saving.');
		} else if (this.state.activeTab === 'Carcinogens/\\r\\nSpec. Consid./\\r\\nTarget Organs' && this.state.editorsOpen.includes('chem_image_toxic2')) {
			this.showAlert('Editor Open', 'Please close the TRI image editor before saving.');
		} else if (this.state.activeTab === 'Toxic Info' && this.state.editorsOpen.includes('chem_image_toxic_info')) {
			this.showAlert('Editor Open', 'Please close the image editor before saving.');
		} else if (this.state.activeTab === 'Usage/\\r\\nMisc. Info' && this.state.editorsOpen.includes('chem_image_misc_info')) {
			this.showAlert('Editor Open', 'Please close the image editor before saving.');
		} else if (this.state.activeTab === 'Stability/\\r\\nReactivity' && this.state.editorsOpen.includes('chem_image_stab_react')) {
			this.showAlert('Editor Open', 'Please close the image editor before saving.');
		} else if (this.state.activeTab === 'International\\r\\nStandards' && (this.state.editorsOpen.filter(value => 
			['chem_image_intl_above','chem_image_intl_below'].includes(value))).length > 0) {
			this.showAlert('Editor Open', 'Please close the image editor before saving.');					
		} else {
			var chem = this.copyObject(this.state.chem);
			
			// validate data
			var validation = ''; // this.validate(piColumns, job, custColumns, job);
			
			// if errors were returned
			if (!this.isEmpty(validation)) {
				this.showAlert('Data Validation', validation);
			} else {
				// perform data conversions
				this.js2mvc(chem, chemicalColumns);
				this.js2mvc(chem, rtecsColumns);
				this.js2mvc(chem, formulaColumns);
				this.js2mvc(chem, shippingColumns);
				this.js2mvc(chem, nfpaColumns);
				this.js2mvc(chem, hmisColumns);
				this.js2mvc(chem, oshaColumns);
				this.js2mvc(chem, specialColumns);
				this.js2mvc(chem, rmpColumns);
				this.js2mvc(chem, stabReactColumns);
				
				// copy statement IDs from chem_safety_ghs_input to GHS
				this.ghsInputToGHS(chem);
								
				// convert MARINE_POL_PP from 'Y' to 'PP'
				chem.chem_safety.MARINE_POL_PP = chem.chem_safety.MARINE_POL_PP === 'Y' ? 'PP' : null;
				
				// combine active international standards
				var chem_i_standard = [];
				if (chem.chem_i_standard_canada.DELETE_FLAG === null) {
					chem.chem_i_standard_canada.STANDARD_ID = 1;
					chem_i_standard.push(chem.chem_i_standard_canada);
				}
				if (chem.chem_i_standard_europe.DELETE_FLAG === null) {
					chem.chem_i_standard_europe.STANDARD_ID = 2;
					chem_i_standard.push(chem.chem_i_standard_europe);
				}
				if (chem.chem_i_standard_japan.DELETE_FLAG === null) {
					chem.chem_i_standard_japan.STANDARD_ID = 3;
					chem_i_standard.push(chem.chem_i_standard_japan);
				}
				if (chem.chem_i_standard_other.DELETE_FLAG === null) {
					chem.chem_i_standard_other.STANDARD_ID = 10;
					chem_i_standard.push(chem.chem_i_standard_other);
				}
				for (i = 0; i < chem_i_standard.length; i++) {
					chem_i_standard[i].I_STANDARD = encode(chem_i_standard[i].I_STANDARD);
				}
				chem.chem_i_standard = chem_i_standard;
				
				// remove unneeded country-specific Standards
				chem.chem_i_standard_canada = null;
				chem.chem_i_standard_europe = null;
				chem.chem_i_standard_japan = null;
				chem.chem_i_standard_other = null;
				
				// encode html fields so server will accept them
				chem.chem_structure.CHEM_STRUCTURE = encode(chem.chem_structure.CHEM_STRUCTURE);
				chem.chem_safety.USAGE_MISC_INFO = encode(chem.chem_safety.USAGE_MISC_INFO);
				chem.chem_safety.TOXIC_INFO = encode(chem.chem_safety.TOXIC_INFO);
				chem.chem_safety.STAB_REACT = encode(chem.chem_safety.STAB_REACT);
				chem.chem_safety.I_STANDARDS = encode(chem.chem_safety.I_STANDARDS);
				
				// move the target organ selections from the checkboxes to the chem_target_organ table
				this.collectTargetOrgans(chem);

				// Create an object of formData
				const formData = new FormData();

				// add the token to the formData
				formData.append('__RequestVerificationToken', this.props.user.antiForgeryToken);
				
				// for each file uploaded to the structure image table
				var counters = {
					newFileIdx: 0,
					formFileIdx: 0
				};
				
				// add images
				this.addImagesToFormData(formData, counters, chem, 'chem_image_structure', 1);
				this.addImagesToFormData(formData, counters, chem, 'chem_image_ms', 14);
				this.addImagesToFormData(formData, counters, chem, 'chem_image_chemwatch', 11);
				this.addImagesToFormData(formData, counters, chem, 'chem_image_toxic1', 15);
				this.addImagesToFormData(formData, counters, chem, 'chem_image_toxic2', 16);
				this.addImagesToFormData(formData, counters, chem, 'chem_image_toxic_info', 2);
				this.addImagesToFormData(formData, counters, chem, 'chem_image_misc_info', 3);
				this.addImagesToFormData(formData, counters, chem, 'chem_image_stab_react', 4);
				this.addImagesToFormData(formData, counters, chem, 'chem_image_canada_above', 5, 1);
				this.addImagesToFormData(formData, counters, chem, 'chem_image_canada_below', 5, 2);
				this.addImagesToFormData(formData, counters, chem, 'chem_image_europe_above', 6, 1);
				this.addImagesToFormData(formData, counters, chem, 'chem_image_europe_below', 6, 2);
				this.addImagesToFormData(formData, counters, chem, 'chem_image_japan_above', 7, 1);
				this.addImagesToFormData(formData, counters, chem, 'chem_image_japan_below', 7, 2);
				this.addImagesToFormData(formData, counters, chem, 'chem_image_other_above', 10, 1);
				this.addImagesToFormData(formData, counters, chem, 'chem_image_other_below', 10, 2);

				// add the chem to the formData
				var nvpairs = this.createHiddenFormData({ chem: chem });
				for (i = 0; i < nvpairs.length; i++) {
					formData.append(nvpairs[i].name, nvpairs[i].value);
				}

				this.ajax({
					type: 'POST',
					url: this.getConfig().host + '/Reuse/UpdateChemical',
					data: formData,
					contentType: false,
					processData: false,
					overlay: true,
				}).done(function (data) {
					if (data.Success) {
						self.props.parent.showConfirmation(() => {
							var chemId = self.props.params.chemId || data.ID;
							var verb = self.props.params.chemId ? "updated" : "created";
							return (<>
								Chemical <Link to={'/Reuse/Chemicals/' + chemId}>{chemId}</Link> {verb}.
							</>);
						});				
					} else {
						self.showAlert('Server Error', data.Message);
					}			
				}).fail(function (jqXHR, textStatus, errorThrown) {
					self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
				});
			}
		}		
	}
	
	collectTargetOrgans(chem) {
		// for each target organ
		for (var o = 0; o < chem.target_organ.length; o++) {
			// create accessor
			var accessor = 'ORGAN_' + chem.target_organ[o].ORGAN_ID;
			
			// look through existing rows to see if one exists already
			var existingIdx = -1;
			for (var c = 0; c < chem.chem_target_organ.length; c++) {
				// if this row is a match
				if (chem.target_organ[o].ORGAN_ID === chem.chem_target_organ[c].ORGAN_ID) {
					// save the Index
					existingIdx = c;
					
					// exit CTO loop
					break;
				}
			}
			
			// if the checkbox is selected
			if (chem.chem_target_organ_input[accessor]) {
				// if the row doesn't exist
				if (existingIdx === -1) {
					// create a new row
					chem.chem_target_organ.push({
						ORGAN_ID: chem.target_organ[o].ORGAN_ID,
						DELETE_FLAG: null
					});
				}
			} else {
				// if the row exists
				if (existingIdx !== -1) {
					// remove the row
					chem.chem_target_organ.splice(existingIdx, 1);
				}
			}
		}
	}
	
	addImagesToFormData(formData, counters, chem, accessor, image_type, image_display) {
		var i;
		if (image_display === undefined) image_display = null;
		
		// get the data table indicated by the accessor - this is what we are sending to the server
		var data_table = this.getByAccessor(chem, accessor);
		
		// get the state table indicated by the accessor - this is what has the file data in it
		var state_table = this.getByAccessor(this.state.chem, accessor);
		
		// for each image in the data table
		for (i = 0; i < data_table.length; i++) {			
			// set the image type
			data_table[i].IMAGE_TYPE = image_type;
			data_table[i].IMAGE_DISPLAY = image_display;
			
			// if there is a create date
			if (!this.isEmpty(data_table[i].CREATE_DATE)) {
				// make sure it is formatted to send to the server
				data_table[i].CREATE_DATE = this.dateTimeToMVC(this.getDate(data_table[i].CREATE_DATE));
			}
		}
		
		// now go through the state table
		// the data table is a copy of the state table without the files, so we can index both
		for (i = 0; i < state_table.length; i++) {
			// if there is a file
			if (state_table[i].NEW_FILE && state_table[i].NEW_FILE.name) {
				// if this is a new record
				if (!this.isNumeric(state_table[i].IMAGE_ID)) {
					// make up a unique ID so we can match the files on the server
					data_table[i].IMAGE_ID = 'new_' + counters.newFileIdx++;
				}
				
				// add the file information
				formData.append('files[' + (counters.formFileIdx++) + ']', state_table[i].NEW_FILE, data_table[i].IMAGE_ID);
				
				// set flag so the server knows to expect a file
				data_table[i].IMAGE_FILE = 'Y';
			} else {					
				// remove IMAGE_FILE since it is for client-side display only
				delete data_table[i].IMAGE_FILE;
			}
		}
	}

	convertTabToURL(tab) {
		if (tab === 'Physical\\r\\nChemical\\r\\nCharacteristics') tab = 'Physical_Chemical_Characteristics'
		else if (tab === 'Shipping\\r\\nInformation') tab = 'Shipping_Information'
		else if (tab === 'Hazard\\r\\nCategories') tab = 'Hazard_Categories'
		else if (tab === 'Hazard/\\r\\nPrecautionary\\r\\nStatements') tab = 'Hazard_Precautionary_Statements'
		else if (tab === 'Carcinogens/\\r\\nSpec. Consid./\\r\\nTarget Organs') tab = 'Carcinogens_Spec_Consid_Target_Organs'
		else if (tab === 'Toxic Info') tab = 'Toxic_Info'
		else if (tab === 'Usage/\\r\\nMisc. Info') tab = 'Usage_Misc_Info'
		else if (tab === 'Stability/\\r\\nReactivity') tab = 'Stability_Reactivity'
		else if (tab === 'International\\r\\nStandards') tab = 'International_Standards'
		return tab;
	}
	
	convertURLToTab(url) {
		if (url === 'Physical_Chemical_Characteristics') url = 'Physical\\r\\nChemical\\r\\nCharacteristics'
		else if (url === 'Shipping_Information') url = 'Shipping\\r\\nInformation'
		else if (url === 'Hazard_Categories') url = 'Hazard\\r\\nCategories'
		else if (url === 'Hazard_Precautionary_Statements') url = 'Hazard/\\r\\nPrecautionary\\r\\nStatements'
		else if (url === 'Carcinogens_Spec_Consid_Target_Organs') url = 'Carcinogens/\\r\\nSpec. Consid./\\r\\nTarget Organs'
		else if (url === 'Toxic_Info') url = 'Toxic Info'
		else if (url === 'Usage_Misc_Info') url = 'Usage/\\r\\nMisc. Info'
		else if (url === 'Stability_Reactivity') url = 'Stability/\\r\\nReactivity'
		else if (url === 'International_Standards') url = 'International\\r\\nStandards'
		return url;
	}

	onClickTabItem(tab) {
		this.props.navigate('/Reuse/Chemicals/' + this.props.params.chemId + '/' + this.convertTabToURL(tab));
	}

	canClickTabItem(tab) {
		if (this.state.activeTab === 'Profile' && this.state.editorsOpen.includes('chem_alt_name')) {
			this.showAlert('Editor Open', 'Please close the alternative name editor before leaving the Profile tab.');
			return false;
		} else if (this.state.activeTab === 'Profile' && this.state.editorsOpen.includes('chem_alt_cas')) {
			this.showAlert('Editor Open', 'Please close the alternative CAS number editor before leaving the Profile tab.');
			return false;
		} else if (this.state.activeTab === 'Physical\\r\\nChemical\\r\\nCharacteristics' && this.state.editorsOpen.includes('chem_image_structure')) {
			this.showAlert('Editor Open', 'Please close the structure image editor before leaving the Physical Chemical Characteristics tab.');
			return false;
		} else if (this.state.activeTab === 'Physical\\r\\nChemical\\r\\nCharacteristics' && this.state.editorsOpen.includes('chem_image_ms')) {
			this.showAlert('Editor Open', 'Please close the mass spectrometry image editor before leaving the Physical Chemical Characteristics tab.');
			return false;
		} else if (this.state.activeTab === 'Shipping\\r\\nInformation' && this.state.editorsOpen.includes('chem_image_chemwatch')) {
			this.showAlert('Editor Open', 'Please close the Chemwatch Hazard Rating image editor before leaving the Shipping Information tab.');
			return false;
		} else if (this.state.activeTab === 'Hazard\\r\\nCategories' && this.state.editorsOpen.includes('chem_ghs_hh_cat_h')) {
			this.showAlert('Editor Open', 'Please close the Health Hazard editor before leaving the Hazard Categories tab.');
			return false;
		} else if (this.state.activeTab === 'Hazard\\r\\nCategories' && this.state.editorsOpen.includes('chem_ghs_hh_cat_e')) {
			this.showAlert('Editor Open', 'Please close the Environmental Hazard editor before leaving the Hazard Categories tab.');
			return false;
		} else if (this.state.activeTab === 'Hazard\\r\\nCategories' && this.state.editorsOpen.includes('chem_ghs_hh_cat_p')) {
			this.showAlert('Editor Open', 'Please close the Physical Hazard editor before leaving the Hazard Categories tab.');
			return false;
		} else if (this.state.activeTab === 'Carcinogens/\\r\\nSpec. Consid./\\r\\nTarget Organs' && this.state.editorsOpen.includes('chem_image_toxic1')) {
			this.showAlert('Editor Open', 'Please close the TRI image editor before leaving the Carcinogens/Special Considerations/Target Organs tab.');
			return false;
		} else if (this.state.activeTab === 'Carcinogens/\\r\\nSpec. Consid./\\r\\nTarget Organs' && this.state.editorsOpen.includes('chem_image_toxic2')) {
			this.showAlert('Editor Open', 'Please close the TRI image editor before leaving the Carcinogens/Special Considerations/Target Organs tab.');
			return false;
		} else if (this.state.activeTab === 'Toxic Info' && this.state.editorsOpen.includes('chem_image_toxic_info')) {
			this.showAlert('Editor Open', 'Please close the image editor before leaving the Toxic Info tab.');
			return false;
		} else if (this.state.activeTab === 'Usage/\\r\\nMisc. Info' && this.state.editorsOpen.includes('chem_image_misc_info')) {
			this.showAlert('Editor Open', 'Please close the image editor before leaving the Usage/Misc. Info tab.');
			return false;
		} else if (this.state.activeTab === 'Stability/\\r\\nReactivity' && this.state.editorsOpen.includes('chem_image_stab_react')) {
			this.showAlert('Editor Open', 'Please close the image editor before leaving the Stability/Reactivity tab.');
			return false;
		} else if (this.state.activeTab === 'International\\r\\nStandards' && (this.state.editorsOpen.filter(value => 
			['chem_image_intl_above','chem_image_intl_below'].includes(value))).length > 0) {
			this.showAlert('Editor Open', 'Please close the image editor before leaving the International Standards tab.');
			return false;
		}
		
		return true;
	}
	
	renderComplexInput(idx) {
		var complexOptions = this.getComplexOptions();
		var complexAccessor = 'chem_formula.COMPLEX' + idx;
		var numberAccessor = 'chem_formula.COMPLEX_NUMBER' + idx;
		return (
		  <InputGroup>
			<Form.Control style={{ maxWidth: '50px' }} type='text' value={this.getByAccessorForInput(this.state.chem, numberAccessor)}
			  onChange={(event) => this.onChange(numberAccessor, event.target.value)} />
			<Form.Control style={{ maxWidth: '100px' }} as="select" value={this.getByAccessorForInput(this.state.chem, complexAccessor)}
			  onChange={(event) => this.onChange(complexAccessor, event.target.value)}>
				{complexOptions.map((option, optionIdx) => {
				  return (<option key={optionIdx} value={(option.value === undefined || option.value === null) ? '' : option.value}>{option.label}</option>);
				})}
			</Form.Control>
		  </InputGroup>
		);
	}

	renderFormulaInput(idx) {
		var elementOptions = this.getElementOptions();
		var elementAccessor = 'chem_formula.ELEMENT' + idx;
		var numberAccessor = 'chem_formula.NUMBER' + idx;
		return (
		  <InputGroup>
			<Form.Control style={{ maxWidth: '50px' }} as="select" value={this.getByAccessorForInput(this.state.chem, elementAccessor)}
			  onChange={(event) => this.onChange(elementAccessor, event.target.value)}>
				{elementOptions.map((option, optionIdx) => {
				  return (<option key={optionIdx} value={(option.value === undefined || option.value === null) ? '' : option.value}>{option.label}</option>);
				})}
			</Form.Control>
			<Form.Control style={{ maxWidth: '60px' }} type='text' value={this.getByAccessorForInput(this.state.chem, numberAccessor)}
			  onChange={(event) => this.onChange(numberAccessor, event.target.value)} />
		  </InputGroup>
		);
	}
	
	renderFormulaCell(props) {
		return (
			<Form.Group as={Row} controlId={props.column.accessor} style={{ height: '100%' }}>
				<Form.Label column sm={props.labelColWidth} style={{ textAlign: 'right' }} dangerouslySetInnerHTML={{__html: props.column.Header}}></Form.Label>
				<Col sm={props.valueColWidth} style={{ flex: 1, display: 'flex', alignItems: 'center', marginBottom: '14px', background: '#e9ecef', borderRadius: 5 }}>
					<div>{this.renderFormulae(props.value)}</div>
				</Col>
			</Form.Group>
		);
	}

	renderFormula(formula) {
		var self = this;
		if (this.isEmpty(formula)) return null;
		var elements = formula.match(/([A-Z][a-z]?)([0-9]*)/g);
		if (this.isEmpty(elements) || elements.length === 0) return null;
		return elements.map((element, key) => {
			var elementAndNumber = element.match(/^([A-Z][a-z]?)([0-9]*)$/);
			if (self.isEmpty(elementAndNumber[2])) {
				return (<React.Fragment key={key}>{elementAndNumber[1]}</React.Fragment>);
			} else {
				return (<React.Fragment key={key}>{elementAndNumber[1]}<sub>{elementAndNumber[2]}</sub></React.Fragment>);
			}
		});
	}
	
	renderFormulae(formulae) {
		if (this.isEmpty(formulae)) return '';
		var pmatch = formulae.match(/^\(((?:[a-zA-Z]+[0-9]*)+)\)n(?:\s●\s([a-zA-Z0-9]+)\s((?:[a-zA-Z]+[0-9]*)+))?(?:\s●\s([a-zA-Z0-9]+)\s((?:[a-zA-Z]+[0-9]*)+))?$/);
		var match = formulae.match(/^((?:[a-zA-Z]+[0-9]*)+)(?:\s●\s([a-zA-Z0-9]+)\s((?:[a-zA-Z]+[0-9]*)+))?(?:\s●\s([a-zA-Z0-9]+)\s((?:[a-zA-Z]+[0-9]*)+))?$/);
		if (pmatch) {
			return (<>({this.renderFormula(pmatch[1])})n{!this.isEmpty(pmatch[2]) && <> ● {pmatch[2]} {this.renderFormula(pmatch[3])}</>}{!this.isEmpty(pmatch[4]) && <> ● {pmatch[4]} {this.renderFormula(pmatch[5])}</>}</>);
		} else if (match) {
			return (<>{this.renderFormula(match[1])}{!this.isEmpty(match[2]) && <> ● {match[2]} {this.renderFormula(match[3])}</>}{!this.isEmpty(match[4]) && <> ● {match[4]} {this.renderFormula(match[5])}</>}</>);
		} else {
			return (<>{formulae}</>);
		}
	}
	
	renderChemicalName() {
		
		var safetyData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			chemid: this.state.chem.chemical.CHEM_ID
		});
		
		var optionalMargin = {};
		if (!this.state.editable) optionalMargin.marginBottom = '10px';

		return(
		  <Container fluid>
		    <Row>
			  <Col xs={5} style={optionalMargin}>
				  <form action={this.getConfig().host + '/Reuse/SafetyPage'} method='POST' target='_blank' className="float-end">
					{safetyData.map((safetyFormField, index) => {
					  return (<input key={index} type='hidden' name={safetyFormField.name} value={safetyFormField.value} />);
					})}
					<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Safety Sheet</Popover.Header></Popover>}>
					  <input type='image' src={this.getConfig().host + '/Content/Icons/safety_page.gif'} alt="Safety Sheet" />
					</OverlayTrigger>
				  </form>
			  </Col>
			  <Col xs={7} style={{ alignSelf: 'center' }}>
			    {this.state.chemical.CHEM_NAME}
			  </Col>
			</Row>
		  </Container>
		);
	}

	renderDocDownload(props) {
		if (this.isNumeric(props.value) && this.isEmpty(props.row.values.JOB_FILE)) {
			return(
				<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Download</Popover.Header></Popover>}>
					<form action={this.getConfig().host + '/Jobtrack/DownloadJobDoc'} method='POST'>
						<input type='hidden' name='__RequestVerificationToken' value={this.props.user.antiForgeryToken} />
						<input type='hidden' name='docid' value={props.value} />
						<input type='image' src={this.getConfig().host + '/Content/Icons/download.png'} alt="Download" />
					</form>
				</OverlayTrigger>
			);
		} else {
			return (
				<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Pending save</Popover.Header></Popover>}>
					<HourglassSplit />
				</OverlayTrigger>
			);
		}
	}
	
	renderDocImage(imgData) {
		if (!this.isEmpty(imgData)) {
			var style = {
				maxWidth: '300px',
				maxHeight: '300px',
			};
			var alt = 'job image';
			return (<img style={style} src={imgData} alt={alt} />);
		}
	}
	
	renderCanadianSafetyPictogram(props, name) {
		var imgURL = this.getConfig().host + '/Content/EHS_Pictograms/' + name.toLowerCase() + '.gif';
		var imgAlt = 'EHS Pictogram ' + name;
		var accessor = 'chem_safety_ghs_input.CANADA_ISTD_' + name;
		var checkedValue = statementIDMap['CANADA_ISTD_' + name];
		
		return (
		  <>
			<ADACheckbox inline style={{ paddingTop: '8px' }} checked={props.value === checkedValue} 
				onClick={(event) => this.onChange(accessor, event.target.checked ? checkedValue : null)} />
			<img src={imgURL} alt={imgAlt} /> {name}
		  </>
		);
	}

	render() {
		// locate intl standard and images
		var intlStdId = this.state.chem.chem_i_standard_select.STANDARD_ID;
		var chem_i_standard = this.getChemIntlStd(this.state.chem, intlStdId);
		var chem_image_intl_above = this.getIntlStdImgAbove(this.state.chem, intlStdId);
		var chem_image_intl_below = this.getIntlStdImgBelow(this.state.chem, intlStdId);
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Chemical {this.state.chem.chemical.CHEM_ID}&nbsp;&nbsp;
						  {this.state.editable ? 
							<UnlockFill style={{ cursor: 'pointer', marginTop: '-4px' }}
							  onClick={() => this.mergeState({ editable: false })} /> : 
							<LockFill style={{ cursor: 'pointer', marginTop: '-4px' }} 
							  onClick={() => this.mergeState({ editable: true })} />}
						  </div>
					  </Col>
					</Row>
					<Row>
					  <Col style={{ paddingBottom: '10px' }}>
					    <Tabs activeTab={this.convertURLToTab(this.state.activeTab)} canClickTabItem={(tab) => this.canClickTabItem(tab)} onClickTabItem={(tab) => this.onClickTabItem(tab)}>
						  <div label='Profile'>
						    <Container fluid>
							  <Row>
							    <Col xs={6}>
								  <ChemEdit parent={this} columns={chemicalColumns} data={this.state.chem} user={this.props.user} renderKey={this.state.renderKey} editable={this.state.editable} />
								</Col>							  
							    <Col xs={3}>
								  <EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey}
									data={this.state.chem.chem_alt_name} editable={this.state.editable} tableColumns={altNameTableColumns} 
									editColumns={altNameEditColumns} tableName='Reuse_Chemical_AltName' newRecord={emptyAltName}
									onEdit={(editorIsOpen, idx) => this.onEdit('chem_alt_name', editorIsOpen, idx)}
									onChange={(data, callback) => this.onChange('chem_alt_name', data)} />
								</Col>
							    <Col xs={3}>
								  <EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey}
									data={this.state.chem.chem_alt_cas} editable={this.state.editable} tableColumns={altCASTableColumns} 
									editColumns={altCASEditColumns} tableName='Reuse_Chemical_AltCAS' newRecord={emptyAltCAS}
									onEdit={(editorIsOpen, idx) => this.onEdit('chem_alt_cas', editorIsOpen, idx)}
									onChange={(data, callback) => this.onChange('chem_alt_cas', data)} />
								</Col>
							  </Row>
							  <Row>
							    <Col>
								  <ChemEdit parent={this} columns={this.state.rtecsColumns} data={this.state.chem} user={this.props.user} renderKey={this.state.renderKey} editable={this.state.editable}
								  onChange={(accessor, value) => this.onChange(accessor, value)} />
								</Col>
							  </Row>
							</Container>
						  </div>
						  <div label='Physical\r\nChemical\r\nCharacteristics'>
						    <Container>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
								  <ChemEdit parent={this} columns={formulaColumns} data={this.state.chem} user={this.props.user}
									renderKey={this.state.renderKey} editable={this.state.editable}
									onChange={(accessor, value) => this.onChange(accessor, value)} />
								</Col>
							  </Row>
							  <Row>
								<Col>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Structure</div>
								</Col>
							  </Row>
							  <Row>
							    <Col>
								  <EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={emptyImage}
									data={this.state.chem.chem_image_structure} editable={this.state.editable} tableColumns={imageTableColumns} 
									editColumns={imageEditColumns} tableName='Reuse_Chemical_Structure' 
									onEdit={(editorIsOpen, idx) => this.onEdit('chem_image_structure', editorIsOpen, idx)}
									onChange={(data, callback) => this.onChange('chem_image_structure', data)} />
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} columns={structureColumns} data={this.state.chem} user={this.props.user}
								    renderKey={this.state.renderKey} editable={this.state.editable}
									onChange={(accessor, value) => this.onChange(accessor, value)} />
								</Col>
							  </Row>
							  <Row>
								<Col>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Mass Spectrometry</div>
								</Col>
							  </Row>
							  <Row>
							    <Col>
								  <EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={emptyImage}
									data={this.state.chem.chem_image_ms} editable={this.state.editable} tableColumns={imageTableColumns} 
									editColumns={imageEditColumns} tableName='Reuse_Chemical_MassSpectrometry' 
									onEdit={(editorIsOpen, idx) => this.onEdit('chem_image_ms', editorIsOpen, idx)}
									onChange={(data, callback) => this.onChange('chem_image_ms', data)} />
								</Col>
							  </Row>
							</Container>							
						  </div>
						  <div label='Shipping\r\nInformation'>
						    <Container fluid>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} columns={shippingColumns} data={this.state.chem} user={this.props.user}
								    renderKey={this.state.renderKey} editable={this.state.editable}
									onChange={(accessor, value) => this.onChange(accessor, value)} />
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ marginTop: '10px', marginBottom: '10px'}}>
								  <img src={this.getConfig().host + '/Content/Icons/test_rating.gif'} alt={'Test Rating'} width={34} height={33} />&nbsp;&nbsp;&nbsp;
								  <span style={{ fontSize: '18px', fontWeight: 'bold' }}>NFPA data</span>&nbsp;&nbsp;&nbsp;
								  <span style={{ fontSize: '14px'}}>(pertinent to incidental exposures such as spills & fires)</span>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} columns={nfpaColumns} data={this.state.chem} user={this.props.user}
								    renderKey={this.state.renderKey} editable={this.state.editable}
									onChange={(accessor, value) => this.onChange(accessor, value)} />
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ marginTop: '10px', marginBottom: '10px'}}>
								  <span style={{ fontSize: '18px', fontWeight: 'bold' }}>HMIS data</span>&nbsp;&nbsp;&nbsp;
								  <span style={{ fontSize: '14px'}}>(pertinent to routine occupational exposures)</span>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} columns={hmisColumns} data={this.state.chem} user={this.props.user}
								    renderKey={this.state.renderKey} editable={this.state.editable}
									onChange={(accessor, value) => this.onChange(accessor, value)} />
								</Col>
							  </Row>
							  <Row>
								<Col>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Chemwatch Hazard Ratings</div>
								</Col>
							  </Row>
							  <Row>
							    <Col>
								  <EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={emptyImage}
									data={this.state.chem.chem_image_chemwatch} editable={this.state.editable} tableColumns={imageTableColumns} 
									editColumns={imageEditColumns} tableName='Reuse_Chemical_Chemwatch' 
									onEdit={(editorIsOpen, idx) => this.onEdit('chem_image_chemwatch', editorIsOpen, idx)}
									onChange={(data, callback) => this.onChange('chem_image_chemwatch', data)} />
								</Col>
							  </Row>
							</Container>
						  </div>
						  <div label='Hazard\r\nCategories'>
						    <Container fluid>
							  <Row>
							    <Col>
								  <EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={newHazard}
									data={this.state.chem.chem_ghs_hh_cat_h} editable={this.state.editable} tableColumns={hhTableColumns} 
									editColumns={hhEditColumns} tableName='Reuse_Chemical_Health_Hazard' 
									onEdit={(editorIsOpen, idx) => this.onEdit('chem_ghs_hh_cat_h', editorIsOpen, idx)}
									onChange={(data, callback) => this.onChange('chem_ghs_hh_cat_h', data)} />
								</Col>
							    <Col>
								  <EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={newHazard}
									data={this.state.chem.chem_ghs_hh_cat_e} editable={this.state.editable} tableColumns={ehTableColumns} 
									editColumns={ehEditColumns} tableName='Reuse_Chemical_Environmental_Hazard' 
									onEdit={(editorIsOpen, idx) => this.onEdit('chem_ghs_hh_cat_e', editorIsOpen, idx)}
									onChange={(data, callback) => this.onChange('chem_ghs_hh_cat_e', data)} />
								</Col>
							    <Col>
								  <EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={newHazard}
									data={this.state.chem.chem_ghs_hh_cat_p} editable={this.state.editable} tableColumns={phTableColumns} 
									editColumns={phEditColumns} tableName='Reuse_Chemical_Physical_Hazard' 
									onEdit={(editorIsOpen, idx) => this.onEdit('chem_ghs_hh_cat_p', editorIsOpen, idx)}
									onChange={(data, callback) => this.onChange('chem_ghs_hh_cat_p', data)} />
								</Col>
							  </Row>
							</Container>
						  </div>
						  <div label='Hazard/\r\nPrecautionary\r\nStatements'>
							<Container fluid>
							  <Row>
								<Col>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Hazard Statements</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} columns={this.state.hStatementColumns} data={this.state.chem} user={this.props.user}
								    renderKey={this.state.renderKey} editable={this.state.editable}
									onChange={(accessor, value) => this.onChange(accessor, value)} />
								</Col>
							  </Row>
							  <Row>
								<Col>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Precautionary Statements</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} columns={this.state.pStatementColumns} data={this.state.chem} user={this.props.user}
								    renderKey={this.state.renderKey} editable={this.state.editable}
									onChange={(accessor, value) => this.onChange(accessor, value)} />
								</Col>
							  </Row>
							</Container>
						  </div>
						  <div label='Carcinogens/\r\nSpec. Consid./\r\nTarget Organs'>
						    <Container fluid>
							  <Row>
								<Col>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Carcinogen Information</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} columns={oshaColumns} data={this.state.chem} user={this.props.user}
								    renderKey={this.state.renderKey} editable={this.state.editable}
									onChange={(accessor, value) => this.onChange(accessor, value)} />
								</Col>
							  </Row>
							  <Row>
								<Col>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Special Considerations</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} columns={specialColumns} data={this.state.chem} user={this.props.user}
								    renderKey={this.state.renderKey} editable={this.state.editable}
									onChange={(accessor, value) => this.onChange(accessor, value)} />
								</Col>
							  </Row>
							  <Row>
							    <Col sm={6} style={{ borderBottom: '1px solid #eee', borderRight: '1px solid #eee' }}>
								  <ChemEdit parent={this} columns={this.state.toxicColumns[0]} data={this.state.chem.toxic_release_inventory[0]}
									user={this.props.user} renderKey={this.state.renderKey} editable={this.state.editable}
									onChange={(accessor, value) => this.onChangeTRI(accessor, value, 0)} />
								</Col>
							    <Col sm={6} style={{ borderBottom: '1px solid #eee', borderLeft: '1px solid #eee' }}>
								  <ChemEdit parent={this} columns={this.state.toxicColumns[1]} data={this.state.chem.toxic_release_inventory[1]}
									user={this.props.user} renderKey={this.state.renderKey} editable={this.state.editable}
									onChange={(accessor, value) => this.onChangeTRI(accessor, value, 1)} />
								</Col>
							  </Row>
							  <Row>
							    <Col sm={6} style={{ borderBottom: '1px solid #eee', borderRight: '1px solid #eee' }}>
								  <EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={emptyImage}
									data={this.state.chem.chem_image_toxic1} editable={this.state.editable} tableColumns={imageTableColumns} 
									editColumns={imageEditColumns} tableName='Reuse_Chemical_Toxic1' 
									onEdit={(editorIsOpen, idx) => this.onEdit('chem_image_toxic1', editorIsOpen, idx)}
									onChange={(data, callback) => this.onChange('chem_image_toxic1', data)} />
								</Col>
							    <Col sm={6} style={{ borderBottom: '1px solid #eee', borderLeft: '1px solid #eee' }}>
								  <EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={emptyImage}
									data={this.state.chem.chem_image_toxic2} editable={this.state.editable} tableColumns={imageTableColumns} 
									editColumns={imageEditColumns} tableName='Reuse_Chemical_Toxic2' 
									onEdit={(editorIsOpen, idx) => this.onEdit('chem_image_toxic2', editorIsOpen, idx)}
									onChange={(data, callback) => this.onChange('chem_image_toxic2', data)} />
								</Col>
							  </Row>
							  <Row>
								<Col>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>RMP Requirements</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} columns={rmpColumns} data={this.state.chem} user={this.props.user}
								    renderKey={this.state.renderKey} editable={this.state.editable}
									onChange={(accessor, value) => this.onChange(accessor, value)} />
								</Col>
							  </Row>
							  <Row>
								<Col>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Target Organs</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} columns={this.state.organColumns} data={this.state.chem} user={this.props.user}
								    renderKey={this.state.renderKey} editable={this.state.editable}
									onChange={(accessor, value) => this.onChange(accessor, value)} />
								</Col>
							  </Row>
							</Container>
						  </div>
						  <div label='Toxic Info'>
							<Container fluid>
							  <Row>
								<Col>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Toxic Information</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} columns={toxicInfoColumns} data={this.state.chem} user={this.props.user}
								    renderKey={this.state.renderKey} editable={this.state.editable}
									onChange={(accessor, value) => this.onChange(accessor, value)} />
								</Col>
							  </Row>
							  <Row>
								<Col>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Image Upload</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={emptyImage}
									data={this.state.chem.chem_image_toxic_info} editable={this.state.editable} tableColumns={imageTableColumns} 
									editColumns={imageEditColumns} tableName='Reuse_Chemical_Toxic_Info' 
									onEdit={(editorIsOpen, idx) => this.onEdit('chem_image_toxic_info', editorIsOpen, idx)}
									onChange={(data, callback) => this.onChange('chem_image_toxic_info', data)} />
								</Col>
							  </Row>
							</Container>
						  </div>
						  <div label='Usage/\r\nMisc. Info'>
							<Container fluid>
							  <Row>
								<Col>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Usage/Miscellaneous Information</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} columns={usageMiscColumns} data={this.state.chem} user={this.props.user}
								    renderKey={this.state.renderKey} editable={this.state.editable}
									onChange={(accessor, value) => this.onChange(accessor, value)} />
								</Col>
							  </Row>
							  <Row>
								<Col>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Image Upload</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={emptyImage}
									data={this.state.chem.chem_image_misc_info} editable={this.state.editable} tableColumns={imageTableColumns} 
									editColumns={imageEditColumns} tableName='Reuse_Chemical_Misc_Info' 
									onEdit={(editorIsOpen, idx) => this.onEdit('chem_image_misc_info', editorIsOpen, idx)}
									onChange={(data, callback) => this.onChange('chem_image_misc_info', data)} />
								</Col>
							  </Row>
							</Container>
						  </div>
						  <div label='Stability/\r\nReactivity'>
							<Container fluid>
							  <Row>
								<Col>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Stability / Reactivity</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} columns={stabReactColumns} data={this.state.chem} user={this.props.user}
								    renderKey={this.state.renderKey} editable={this.state.editable}
									onChange={(accessor, value) => this.onChange(accessor, value)} />
								</Col>
							  </Row>
							  <Row>
								<Col>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Image Upload</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={emptyImage}
									data={this.state.chem.chem_image_stab_react} editable={this.state.editable} tableColumns={imageTableColumns} 
									editColumns={imageEditColumns} tableName='Reuse_Chemical_Stab_React' 
									onEdit={(editorIsOpen, idx) => this.onEdit('chem_image_stab_react', editorIsOpen, idx)}
									onChange={(data, callback) => this.onChange('chem_image_stab_react', data)} />
								</Col>
							  </Row>
							</Container>
						  </div>
						  <div label='International\r\nStandards'>
							<Container fluid>
							  <Row>
								<Col>
								  <div style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>International Standards</div>
								</Col>
							  </Row>
							  <Row>
							    <Col style={{ borderBottom: '1px solid #eee' }}>
								  <ChemEdit parent={this} columns={intlStdColumns} data={this.state.chem} user={this.props.user}
								    renderKey={this.state.renderKey} editable={this.state.editable}
									onChange={(accessor, value) => this.onChange(accessor, value)} />
								</Col>
							  </Row>
							  {this.state.chem.chem_i_standard_select.ACTIVE_FLAG === 'Y' && <>
								{this.state.chem.chem_i_standard_select.STANDARD_ID === '1' && <>
								  <Row>
								    <Col>
									  <div style={{ fontSize: '14px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Canadian Safety Pictograms</div>
									</Col>
								  </Row>
								  <Row>
									<Col style={{ borderBottom: '1px solid #eee' }}>
									  <ChemEdit parent={this} columns={canadaGHSColumns} data={this.state.chem}
										user={this.props.user} renderKey={this.state.renderKey} editable={this.state.editable}
										onChange={(accessor, value) => this.onChange(accessor, value)} />
									</Col>
								  </Row>
								</>}
								{this.state.chem.chem_i_standard_select.STANDARD_ID === '2' && <>
								  <Row>
									<Col style={{ borderBottom: '1px solid #eee' }}>
									  <ChemEdit parent={this} columns={echaColumns} data={this.state.chem}
										user={this.props.user} renderKey={this.state.renderKey} editable={this.state.editable}
										onChange={(accessor, value) => this.onChange(accessor, value)} />
									</Col>
								  </Row>
								</>}
								<Row>
								  <Col>
									<div style={{ fontSize: '14px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Images Displayed Above Text</div>
								  </Col>
								</Row>
								<Row>
							      <Col style={{ borderBottom: '1px solid #eee' }}>
									<EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={emptyImage}
									  data={chem_image_intl_above} editable={this.state.editable} tableColumns={imageTableColumns} 
									  editColumns={imageEditColumns} tableName='Reuse_Chemical_Intl_Above' 
									  onEdit={(editorIsOpen, idx) => this.onEdit('chem_image_intl_above', editorIsOpen, idx)}
									  onChange={(data, callback) => this.onChange('chem_image_intl_above', data)} />
								  </Col>
								</Row>
								<Row>
								  <Col>
									<div style={{ fontSize: '14px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Text</div>
								  </Col>
								</Row>
								<Row>
							      <Col style={{ borderBottom: '1px solid #eee' }}>
									<ChemEdit parent={this} columns={intlStdTextColumns} data={{ chem_i_standard: chem_i_standard }}
									  user={this.props.user} renderKey={this.state.renderKey} editable={this.state.editable}
									  onChange={(accessor, value) => this.onChange(accessor, value)} />
								  </Col>
							    </Row>
								<Row>
								  <Col>
									<div style={{ fontSize: '14px', fontWeight: 'bold', marginTop: '10px', marginBottom: '10px' }}>Images Displayed Below Text</div>
								  </Col>
								</Row>
								<Row>
							      <Col style={{ borderBottom: '1px solid #eee' }}>
									<EditTable parent={this} user={this.props.user} renderKey={this.state.renderKey} newRecord={emptyImage}
									  data={chem_image_intl_below} editable={this.state.editable} tableColumns={imageTableColumns} 
									  editColumns={imageEditColumns} tableName='Reuse_Chemical_Intl_Below' 
									  onEdit={(editorIsOpen, idx) => this.onEdit('chem_image_intl_below', editorIsOpen, idx)}
									  onChange={(data, callback) => this.onChange('chem_image_intl_below', data)} />
								  </Col>
								</Row>
							  </>}
							</Container>
						  </div>
						</Tabs>
					  </Col>
					</Row>
					<Form.Group as={Row}>
					  <Col>
						{this.state.editable && <Button style={{ marginLeft: '10px' }} id="save" variant="warning" type="button" 
							className="float-end" onClick={(event) => this.onSubmit(event)}>Save</Button>}
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			</Container>
		</>);
	}
}

// these are GHS statements that are chosen from a list of IDs of the same type
const statementTypeMap = {
	DOT_PIH: 7,
	NFPA_HEALTH_HAZARD: 51,
	NFPA_FLAMMABILITY_HAZARD: 52,
	NFPA_INSTABILITY_HAZARD: 54,
	NFPA_SPECIAL_HAZARD: 53,
	HMIS_HEALTH_HAZARD: 61,
	HMIS_FLAMMABILITY_HAZARD: 62,
	HMIS_PHYSICAL_HAZARD: 63,
	ACGIH: 80,
	EPA: 81,
	IARC: 82,
	NIOSH: 83,
	NTP: 84
};

// these are GHS statements that are selected with a checkbox
const statementIDMap = {
	HMIS_CHRONIC_HEALTH_HAZARD: 374,
	CANADA_ISTD_A: 11,
	CANADA_ISTD_B1: 12,
	CANADA_ISTD_B2: 13,
	CANADA_ISTD_B3: 14,
	CANADA_ISTD_B4: 22,
	CANADA_ISTD_B5: 23,
	CANADA_ISTD_B6: 24,
	CANADA_ISTD_C: 15,
	CANADA_ISTD_D1A: 16,
	CANADA_ISTD_D1B: 17,
	CANADA_ISTD_D2A: 18,
	CANADA_ISTD_D2B: 19,
	CANADA_ISTD_E: 20,
	CANADA_ISTD_F: 21,
	EUROPE_SVHC_AUTH: 600,
	EUROPE_SVHC_CAND: 601,
	EUROPE_57A: 602,
	EUROPE_57B: 603,
	EUROPE_57C: 604,
	EUROPE_57D: 605,
	EUROPE_57E: 606,
	EUROPE_57F: 607
};

const chemicalColumns = [
	{ Header: 'Prefix', accessor: 'chemical.PREFIX', row: 0, col: 0 },
	{ Header: 'Name', accessor: 'chemical.CHEM_NAME', row: 0, col: 1 },
	{ Header: 'CAS Number', accessor: 'chemical.CAS_NUMBER', row: 1, col: 0 },
	{ Header: 'No CAS Number', accessor: 'chemical.NO_CAS', type: 'checkbox', row: 1, col: 1 }
];

const emptyAltName = {
	id: null,
	ALT_NAME_ID: '(new)',
	ALT_PREFIX: '',
	ALT_NAME: ''
};

const altNameTableColumns = [
	{ Header: '', accessor: 'ALT_NAME_ID', show: false },
	{ Header: '', accessor: 'ALT_PREFIX', show: false },
	{ Header: 'Alternate Names', accessor: 'ALT_NAME',
		Cell: props => (props.row.values.ALT_PREFIX||'') + (props.value||'') }
];

const altNameEditColumns = [
	{ Header: 'ID', accessor: 'ALT_NAME_ID', editable: false },
	{ Header: 'Prefix', accessor: 'ALT_PREFIX' },
	{ Header: 'Name', accessor: 'ALT_NAME' }
];

const emptyAltCAS = {
	id: null,
	ALT_CAS_ID: '(new)',
	ALT_CAS: ''
};

const altCASTableColumns = [
	{ Header: '', accessor: 'ALT_CAS_ID', show: false },
	{ Header: 'Alternate CAS', accessor: 'ALT_CAS' }
];

const altCASEditColumns = [
	{ Header: 'ID', accessor: 'ALT_CAS_ID', editable: false },
	{ Header: 'Alternate CAS', accessor: 'ALT_CAS' }
];

const rtecsColumns = [
	{ Header: 'RTECS Number', accessor: 'chem_safety.RTEC_NUM', row: 0, col: 0 },
	{ Header: 'No RTECS Number', accessor: 'chem_safety.NO_RTECS', type: 'checkbox', row: 0, col: 1 },
	{ Header: 'RTECS URL', accessor: 'chem_safety.RTECS_URL', row: 0, col: 2 },
	{ Header: 'Harmonized System', accessor: 'chem_safety.HARMONIZED_SYS', row: 0, col: 3 },
	{ Header: 'MDL #', accessor: 'chem_safety.MDL_NUM', row: 1, col: 0 },
	{ Header: 'PubChem #', accessor: 'chem_safety.PUBCHEM_CID', row: 1, col: 1 },
	{ Header: 'PubChem URL', accessor: 'chem_safety.PUBCHEM', row: 1, col: 2 },
	{ Header: 'Reaxys-RN', accessor: 'chemical.REAXYS_RN', row: 1, col: 3 },
	{ Header: 'State', accessor: 'chemical.CHEM_STATE', type: 'select', row: 2, col: 0,
		options: [{ value: null, label: 'Select...' },{ value: 'liquid', label: 'Liquid' },{ value: 'solid', label: 'Solid' },{ value: 'gas', label: 'Gas' }]},
	{ Header: 'ChemBank #1', accessor: 'chem_safety.CHEMBANK_ID', row: 2, col: 1 },
	{ Header: 'ChemBank #2', accessor: 'chem_safety.CHEMBANK_ID2', row: 2, col: 2 },
	{ Header: 'No ChemBank #', accessor: 'chem_safety.NO_CHEMBANK', type: 'checkbox', row: 2, col: 3 },
	{ Header: 'Storage', accessor: 'chemical.STORAGE', type: 'select', row: 3, col: 0,
		options: { value: 'STORAGE', label: 'STORAGE', entity: 'REUSE.STORAGE_TEMP_SELECT_VW', order: 'CHEM_ID desc',
			search: { Operator: 'or', Children: [
				{ Attribute: 'CHEM_ID', Operator: '<', LongValue: 0 }
			]}}},
	{ Header: 'Zinc 15 #1', accessor: 'chem_safety.ZINC_NUM', row: 3, col: 1 },
	{ Header: 'Zinc 15 #2', accessor: 'chem_safety.ZINC_NUM2', row: 3, col: 2 },
	{ Header: 'No Zinc 15 #', accessor: 'chem_safety.NO_ZINC15', type: 'checkbox', row: 3, col: 3 },
	{ Header: 'SciFinder', accessor: 'chem_safety.SCIFINDER', type: 'textarea', row: 4, col: 0,
		colwidth: 6, labelColWidth: 2, valueColWidth: 10 },
	{ Header: 'EPA CompTox', accessor: 'chem_safety.EPA_COMP_TOX', row: 4, col: 2 },
	{ Header: 'No EPA CompTox', accessor: 'chem_safety.NO_EPA_COMP_TOX', type: 'checkbox', row: 4, col: 3 },
	{ Header: 'Catalog', accessor: 'chemical.CATALOG_NAME', row: 5, col: 0 },
	{ Header: 'Catalog Year', accessor: 'chemical.CATALOG_YEAR', row: 5, col: 1 },
	{ Header: 'Catalog Number', accessor: 'chemical.CATALOG_NUMBER', row: 5, col: 2 },
	{ Header: 'Inhibitor', accessor: 'chemical.INHIBITOR_NOTE', type: 'textarea', row: 5, col: 3 },
	{ Header: 'Pricing', accessor: 'chemical.PRICE', row: 6, col: 0 },
	{ Header: 'Amount', accessor: 'chemical.AMOUNT', row: 6, col: 1 },
	{ Header: 'Unit', accessor: 'chemical.UNIT_ID', type: 'select', row: 6, col: 2,
		options: { value: 'UNIT_ID', label: 'UNIT_NAME', entity: 'REUSE.UNIT_SIZE',
			search: { Attribute: 'DELETE_FLAG', Operator: 'is null' }}},
	{ Header: 'Hazard', accessor: 'chemical.HAZARD_NOTE', type: 'textarea', row: 6, col: 3 },
	{ Header: 'Radioactive', accessor: 'chemical.RADIOACTIVE_FLAG', type: 'checkbox', row: 7, col: 0 },
	{ Header: 'Out of Production', accessor: 'chemical.OUT_OF_PROD', type: 'checkbox', row: 7, col: 1 },
	{ Header: 'Deleted', accessor: 'chemical.DELETE_FLAG', type: 'checkbox', row: 7, col: 2 },
	{ Header: 'Color', accessor: 'chemical.COLOR_NOTE', type: 'textarea', row: 7, col: 3 },
	{ Header: 'Modified', accessor: 'chemical.MODIFIED', row: 8, col: 0, colwidth: 12, editable: false }
];

const formulaColumns = [
	{ Header: 'Formula 1', accessor: 'chem_formula.FORMULA1', row: 0, col: 0,
		Cell: props => props.parent.renderFormulaInput(1) },
	{ Header: 'Formula 2', accessor: 'chem_formula.FORMULA2', row: 0, col: 1,
		Cell: props => props.parent.renderFormulaInput(2) },
	{ Header: 'Formula 3', accessor: 'chem_formula.FORMULA3', row: 0, col: 2,
		Cell: props => props.parent.renderFormulaInput(3) },
	{ Header: 'Formula 4', accessor: 'chem_formula.FORMULA4', row: 0, col: 3,
		Cell: props => props.parent.renderFormulaInput(4) },
	{ Header: 'Formula 5', accessor: 'chem_formula.FORMULA5', row: 1, col: 0,
		Cell: props => props.parent.renderFormulaInput(5) },
	{ Header: 'Formula 6', accessor: 'chem_formula.FORMULA6', row: 1, col: 1,
		Cell: props => props.parent.renderFormulaInput(6) },
	{ Header: 'Formula 7', accessor: 'chem_formula.FORMULA7', row: 1, col: 2,
		Cell: props => props.parent.renderFormulaInput(7) },
	{ Header: 'Polymer', accessor: 'chemical.POLYMER_FLAG', type: 'checkbox', row: 1, col: 3 },
	{ Header: 'Complex 1', accessor: 'chem_formula.COMPLEX1', row: 2, col: 0,
		Cell: props => props.parent.renderComplexInput(1) },
	{ Header: 'Complex 2', accessor: 'chem_formula.COMPLEX2', row: 2, col: 1,
		Cell: props => props.parent.renderComplexInput(2) },
	{ Header: 'Heavy Atom Count', accessor: 'chemical.HEAVY_ATOM', row: 2, col: 2 },
	{ Header: 'Molecular Weight', accessor: 'chemical.MOL_WGHT', row: 2, col: 3 },
	{ Header: 'Viscosity (cP)', accessor: 'chemical.VISCOSITY', row: 3, col: 0 },
	{ Header: 'Viscosity (°C)', accessor: 'chemical.VISCOSITY_TEMP', row: 3, col: 1 },
	{ Header: 'Complexity', accessor: 'chemical.COMPLEXITY', row: 3, col: 2 },
	{ Header: 'pH', accessor: 'chemical.PH_INFO', row: 3, col: 3 },
	{ Header: 'Water Solubility (g/L)', accessor: 'chemical.WATER_SOL', row: 4, col: 0 },
	{ Header: 'Water Solubility (°C)', accessor: 'chemical.WATER_SOL_TEMP', row: 4, col: 1 },
	{ Header: 'H-Bond Donors', accessor: 'chemical.HBOND_DONOR', row: 4, col: 2 },
	{ Header: 'H-Bond Acceptors', accessor: 'chemical.HBOND_ACCEP', row: 4, col: 3 },
	{ Header: 'pKa 1', accessor: 'chemical.PKA', row: 5, col: 0 },
	{ Header: 'pKa 1 (°C)', accessor: 'chemical.PKA_TEMP', row: 5, col: 1 },
	{ Header: 'Rotatable Bonds', accessor: 'chemical.ROTATABLE_BOND', row: 5, col: 2 },
	{ Header: 'Stereocenters', accessor: 'chemical.STEREOCENTERS', row: 5, col: 3 },
	{ Header: 'pKa 2', accessor: 'chemical.PKA2', row: 6, col: 0 },
	{ Header: 'pKa 3', accessor: 'chemical.PKA3', row: 6, col: 1 },
	{ Header: 'Acid Value', accessor: 'chemical.ACID_VALUE', row: 6, col: 2 },
	{ Header: 'Saponification Value', accessor: 'chemical.SAPONIFICATION', row: 6, col: 3 },
	{ Header: 'cLogP', accessor: 'chemical.CLOGP', row: 7, col: 0 },
	{ Header: 'cLogS', accessor: 'chemical.CLOGS', row: 7, col: 1 },
	{ Header: 'Surface Tension (mN/m or dynes/cm)', accessor: 'chemical.SURF_TENSION', row: 7, col: 2 },
	{ Header: 'Surface Tension (°C)', accessor: 'chemical.SURF_TENSION_TEMP', row: 7, col: 3 },
	{ Header: 'Refractive Index From', accessor: 'chemical.REFRAC_INDEX', row: 8, col: 0 },
	{ Header: 'Refractive Index To', accessor: 'chemical.REFRAC_INDEX2', row: 8, col: 1 },
	{ Header: 'LEL %', accessor: 'chemical.LEL', row: 8, col: 2 },
	{ Header: 'UEL %', accessor: 'chemical.UEL', row: 8, col: 3 },
	{ Header: 'Density', accessor: 'chemical.DENSITY', row: 9, col: 0 },
	{ Header: 'Density (units)', accessor: 'chemical.DENSITY_UNIT', type: 'select', row: 9, col: 1,
		options: [{ value: null, label: 'Select...' },{ value: 'g/cm3', label: 'g/cm3' },{ value: 'g/ml', label: 'g/ml' }]},
	{ Header: 'Density (°C)', accessor: 'chemical.DENSITY_TEMP', row: 9, col: 2 },
	{ Header: 'Polar Surface Area (A<sup>2</sup>)', accessor: 'chemical.POLAR_SURFACE', row: 9, col: 3 },
	{ Header: 'Flash Point (°C)', accessor: 'chemical.FLASH_POINT', row: 10, col: 0 },
	{ Header: 'Flash Point Cup', accessor: 'chemical.FLASHPOINT_CUP', type: 'select', row: 10, col: 1,
		options: [{ value: null, label: 'Select...' },{ value: 'closed', label: 'closed' },{ value: 'open', label: 'open' }]},
	{ Header: 'Autoignition Temp (°C)', accessor: 'chemical.AUTOIGN_TEMP', row: 10, col: 2 },
	{ Header: 'Decomposition Temp (°C)', accessor: 'chemical.DECOMP_TEMP', row: 10, col: 3 },
	{ Header: 'OSHA Comb. Class', accessor: 'chemical.CLASS_ID', type: 'select', row: 11, col: 0,
		options: { value: 'CLASS_ID', label: 'CLASS_NAME', entity: 'REUSE.CHEM_CLASS', order: 'CLASS_NAME',
			search: { Attribute: 'DELETE_FLAG', Operator: 'is null' }}},
	{ Header: 'NFPA Extinguishing Methods 1', accessor: 'chemical.NFPA_EXTINGUISHING1', row: 11, col: 1 },
	{ Header: 'NFPA Extinguishing Methods 2', accessor: 'chemical.NFPA_EXTINGUISHING2', row: 11, col: 2 },
	{ Header: 'Odor Threshold', accessor: 'chemical.ODOR_THRESHOLD', row: 11, col: 3 },
	{ Header: 'Critical Pressure', accessor: 'chemical.CRITICAL_PRESS', row: 12, col: 0 },
	{ Header: 'Critical Pressure (units)', accessor: 'chemical.CRITICAL_PRESS_UNIT', type: 'select', row: 12, col: 1,
		options: [{ value: null, label: 'Select...' },{ value: 'atm', label: 'atm' },{ value: 'MPa', label: 'MPa' }]},
	{ Header: 'Critical Temperature (°C)', accessor: 'chemical.CRITICAL_TEMP', row: 12, col: 2 },
	{ Header: 'Critical Density g/cm<sup>3</sup>', accessor: 'chemical.CRITICAL_DENSITY', row: 12, col: 3 },
	{ Header: 'Vapor Pressure (1 hPa = 0.75 mmHg)', accessor: 'chemical.VAPOR_PRESS', row: 13, col: 0 },
	{ Header: 'Vapor Pressure (units)', accessor: 'chemical.VAPOR_PRESS_U', type: 'select', row: 13, col: 1,
		options: [{ value: null, label: 'Select...' },{ value: 'psi', label: 'psi' },
			{ value: 'hPA', label: 'hPA' },{ value: 'mmHg', label: 'mmHg' }]},
	{ Header: 'Vapor Pressure (°C)', accessor: 'chemical.VAPOR_PRESS_T', row: 13, col: 2 },
	{ Header: 'Bonding Type', accessor: 'chemical.BONDING_TYPE', type: 'select', row: 13, col: 3,
		options: [{ value: null, label: 'Select...' },{ value: 'ionic', label: 'ionic' },
			{ value: 'polar covalent', label: 'polar covalent' },{ value: 'nonpolar covalent', label: 'nonpolar covalent' }]},
	{ Header: 'Boiling Point (°C)', accessor: 'chemical.BOILING_PT', row: 14, col: 0 },
	{ Header: 'Boiling Point (mm Hg)', accessor: 'chemical.ATMOS_PRESS', row: 14, col: 1 },
	{ Header: 'Relative Liquid Density (water = 1.0)', accessor: 'chemical.REL_LIQUID_DENSITY', row: 14, col: 2 },
	{ Header: 'Relative Vapor Density (air = 1.0)', accessor: 'chemical.REL_VAPOR_DENSITY', row: 14, col: 3 },
	{ Header: 'Melting Point (°C)', accessor: 'chemical.MELTING_POINT', row: 15, col: 0 },
	{ Header: 'Ionic Character %', accessor: 'chemical.IONIC_CHAR', row: 15, col: 2 },
	{ Header: 'Ionization Potential (eV)', accessor: 'chemical.IONIZ_POT', row: 15, col: 3 },
	{ Header: 'Typical Impurities', accessor: 'chemical.IMPURITIES', row: 16, col: 0 },
	{ Header: 'Conversion Factor (ppm to mg/m<sup>3</sup>)', accessor: 'chemical.PPM_CONVERSION', row: 16, col: 1 },
	{ Header: 'Dielectric Constant', accessor: 'chemical.DIELECTRIC_CONSTANT', row: 16, col: 2 },
	{ Header: 'Dielectric Constant (°C)', accessor: 'chemical.DIELECTRIC_CONSTANT_TEMP', row: 16, col: 3 },
	{ Header: 'Apolar Desolvation (kcal/mol)', accessor: 'chemical.APOLAR_DESOLV', row: 17, col: 0 },
	{ Header: 'Polar Desolvation (kcal/mol)', accessor: 'chemical.POLAR_DESOLV', row: 17, col: 1 },
];

const structureColumns = [
	{ Header: 'Structure Description', accessor: 'chem_structure.CHEM_STRUCTURE', type: 'editor', labelColWidth: 2, valueColWidth: 10 }
];

const emptyImage = {
	id: null,
	IMAGE_ID: null,
	CHEM_ID: null,
	IMAGE_NAME: '',
	IMAGE_FILE: null,
	IMAGE_EXT: '',
	IMAGE_TYPE: null,
	IMAGE_DISPLAY: null,
	COMMENTS: '',
	CREATE_DATE: null,
	CREATED_BY: '',
	MODIF_DATE: null,
	MODIF_BY: '',
	DELETE_FLAG: null,
	NEW_FILE: null
};

const imageTableColumns = [
	{ Header: props => <Download />, accessor: 'IMAGE_ID', width: 25,
		Cell: props => props.parent.props.parent.renderDocDownload(props) },
	{ Header: 'Name', accessor: 'IMAGE_NAME', width: 125 },
	{ Header: 'Image', accessor: 'IMAGE_FILE', width: 306,
		Cell: props => props.parent.props.parent.renderDocImage(props.value) },
	{ Header: 'Type', accessor: 'IMAGE_EXT', width: 50 },
	{ Header: 'Comments', accessor: 'COMMENTS', width: 400 },
	{ Header: 'Updated', accessor: 'UPDATED', width: 200 },
	{ Header: '', accessor: 'NEW_FILE', show: false }
];

const imageEditColumns = [
	{ Header: 'Name', accessor: 'IMAGE_NAME', row: 0, col: 0 },
	{ Header: 'New File', accessor: 'NEW_FILE', type: 'file', row: 0, col: 1 },
	{ Header: 'Updated', accessor: 'UPDATED', row: 0, col: 2, editable: false },
	{ Header: 'Comments', accessor: 'COMMENTS', type: 'textarea', row: 1, col: 0, colwidth: 12 }
];

const shippingColumns = [
	{ Header: 'PSN', accessor: 'chem_safety.PSN', row: 0, col: 0 },
	{ Header: 'Division 1', accessor: 'chem_safety.H_DIVISION1', type: 'select', row: 0, col: 1,
		options: { value: 'DIVISION_ID', label: 'DIVISION_NAME', entity: 'REUSE.HAZARD_DIVISION', order: 'DIVISION_NAME',
			search: { Attribute: 'DELETE_FLAG', Operator: 'is null' }}},
	{ Header: 'Division 2', accessor: 'chem_safety.H_DIVISION2', type: 'select', row: 0, col: 2,
		options: { value: 'DIVISION_ID', label: 'DIVISION_NAME', entity: 'REUSE.HAZARD_DIVISION', order: 'DIVISION_NAME',
			search: { Attribute: 'DELETE_FLAG', Operator: 'is null' }}},
	{ Header: 'Division 3', accessor: 'chem_safety.H_DIVISION3', type: 'select', row: 0, col: 3,
		options: { value: 'DIVISION_ID', label: 'DIVISION_NAME', entity: 'REUSE.HAZARD_DIVISION', order: 'DIVISION_NAME',
			search: { Attribute: 'DELETE_FLAG', Operator: 'is null' }}},
	{ Header: 'Packing Group', accessor: 'chem_safety.PACKING_GROUP', type: 'select', row: 1, col: 0,
		options: [{ value: null, label: 'Select...' },{ value: 'I', label: 'I' },{ value: 'II', label: 'II' },{ value: 'III', label: 'III' }]},
	{ Header: 'ERG Guide #', accessor: 'chem_safety.ERG_GUIDE', row: 1, col: 1 },
	{ Header: 'DOT UN #', accessor: 'chem_safety.DOT_UN', row: 1, col: 2 },
	{ Header: 'DOT PIH Zone', accessor: 'chem_safety_ghs_input.DOT_PIH', type: 'select', row: 1, col: 3,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.CHEM_SAFETY_STATEMENT', order: 'STATEMENT_CODE',
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: statementTypeMap.DOT_PIH },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
			]}}},
	{ Header: '<span style="font-size: 12px; text-decoration: underline;">(49 CFR §172.101, Appendix B)<span>', 
		accessors: ['chem_safety.MARINE_POL','chem_safety.MARINE_POL_PP'], type: 'checkbox', row: 2, col: 0, colwidth: 6,
		labels: ['DOT Marine Pollutant (≥10%)','DOT Marine Pollutant - PP Severe (≥1%)'], checkboxColWidth: 12 },
	{ Header: 'RQ', accessor: 'chem_safety.RQ', type: 'select', row: 2, col: 2, 
		options: [{ value: null, label: 'Select...' },{ value: '1', label: '1 lb.' },{ value: '10', label: '10 lb.' }]},
	{ Header: '', accessors: ['chem_safety.CERCLA','chem_safety.EPCLA'], type: 'checkbox', row: 2, col: 3,
		labels: ['CERCLA','EPCLA'], checkboxColWidth: 12 },
];

const nfpaColumns = [
	{ Header: '<div style="background-color: blue; color: white; padding-right: 4px;">Health Hazard</div>', 
		accessor: 'chem_safety_ghs_input.NFPA_HEALTH_HAZARD', type: 'select', row: 0, col: 0,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.CHEM_SAFETY_STATEMENT', order: 'STATEMENT_CODE',
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: statementTypeMap.NFPA_HEALTH_HAZARD },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
			]}}},
	{ Header: '<div style="background-color: red; color: white; padding-right: 4px;">Flammability Hazard</div>', 
		accessor: 'chem_safety_ghs_input.NFPA_FLAMMABILITY_HAZARD', type: 'select', row: 0, col: 1,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.CHEM_SAFETY_STATEMENT', order: 'STATEMENT_CODE',
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: statementTypeMap.NFPA_FLAMMABILITY_HAZARD },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
			]}}},
	{ Header: '<div style="background-color: yellow; padding-right: 4px;">Instability Hazard</div>', 
		accessor: 'chem_safety_ghs_input.NFPA_INSTABILITY_HAZARD', type: 'select', row: 0, col: 2,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.CHEM_SAFETY_STATEMENT', order: 'STATEMENT_CODE',
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: statementTypeMap.NFPA_INSTABILITY_HAZARD },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
			]}}},
	{ Header: '<div style="padding-right: 4px;">Special Hazard</div>', 
		accessor: 'chem_safety_ghs_input.NFPA_SPECIAL_HAZARD', type: 'select', row: 0, col: 3,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.CHEM_SAFETY_STATEMENT', order: 'STATEMENT_CODE',
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: statementTypeMap.NFPA_SPECIAL_HAZARD },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
			]}}}
];

const hmisColumns = [
	{ Header: '<div style="background-color: blue; color: white; padding-right: 4px;">Health Hazard</div>', 
		accessor: 'chem_safety_ghs_input.HMIS_HEALTH_HAZARD', type: 'select', row: 0, col: 0,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.CHEM_SAFETY_STATEMENT', order: 'STATEMENT_CODE',
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: statementTypeMap.HMIS_HEALTH_HAZARD },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
			]}}},
	{ Header: '<div style="background-color: red; color: white; padding-right: 4px;">Flammability Hazard</div>', 
		accessor: 'chem_safety_ghs_input.HMIS_FLAMMABILITY_HAZARD', type: 'select', row: 0, col: 1,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.CHEM_SAFETY_STATEMENT', order: 'STATEMENT_CODE',
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: statementTypeMap.HMIS_FLAMMABILITY_HAZARD },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
			]}}},
	{ Header: '<div style="background-color: orange; padding-right: 4px;">Physical Hazard</div>', 
		accessor: 'chem_safety_ghs_input.HMIS_PHYSICAL_HAZARD', type: 'select', row: 0, col: 2,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.CHEM_SAFETY_STATEMENT', order: 'STATEMENT_CODE',
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: statementTypeMap.HMIS_PHYSICAL_HAZARD },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
			]}}},
	{ Header: '<div style="background-color: blue; color: white; padding-right: 4px;">Chronic Health Hazard</div>', 
		accessor: 'chem_safety_ghs_input.HMIS_CHRONIC_HEALTH_HAZARD', type: 'checkbox', row: 0, col: 3,
		value: statementIDMap.HMIS_CHRONIC_HEALTH_HAZARD }
];

const newHazard = {
	id: null,
	CHEM_HH_ID: null,
	CHEM_ID: null,
	COMMENTS: null,
	DELETE_FLAG: null,
	HH_ID: null,
	MODIF_BY: '',
	MODIF_DATE: null
};

const hhTableColumns = [
	{ Header: 'Health Hazard', accessor: 'HAZARD_NAME' },
	{ Header: 'Category', accessor: 'CAT_NAME' }
];

const hhEditColumns = [
	{ Header: 'Health Hazard', accessor: 'HAZARD_ID', labelAccessor: 'HAZARD_NAME', type: 'select',
		options: { value: 'HAZARD_ID', label: 'HAZARD_NAME', entity: 'REUSE.HAZARD_SELECT_VW', order: 'HAZARD_NAME',
			search: { Attribute: 'HAZARD_TYPE', Operator: '=', StringValue: 'H' }
	}},
	{ Header: 'Category', accessor: 'HH_ID', labelAccessor: 'CAT_NAME', type: 'select',
		options: { value: 'HH_ID', label: 'CAT_NAME', entity: 'REUSE.HAZARD_CAT_SELECT_VW', order: 'CAT_NAME',
			search: { Operator: 'and', Children: [
				{ Attribute: 'HAZARD_ID', Operator: '=', LongAccessor: 'HAZARD_ID' },
				{ Attribute: 'HAZARD_TYPE', Operator: '=', StringValue: 'H' }
	]}}},
];

const ehTableColumns = [
	{ Header: 'Environmental Hazard', accessor: 'HAZARD_NAME' },
	{ Header: 'Category', accessor: 'CAT_NAME' }
];

const ehEditColumns = [
	{ Header: 'Environmental Hazard', accessor: 'HAZARD_ID', labelAccessor: 'HAZARD_NAME', type: 'select',
		options: { value: 'HAZARD_ID', label: 'HAZARD_NAME', entity: 'REUSE.HAZARD_SELECT_VW', order: 'HAZARD_NAME',
			search: { Attribute: 'HAZARD_TYPE', Operator: '=', StringValue: 'E' }
	}},
	{ Header: 'Category', accessor: 'HH_ID', labelAccessor: 'CAT_NAME', type: 'select',
		options: { value: 'HH_ID', label: 'CAT_NAME', entity: 'REUSE.HAZARD_CAT_SELECT_VW', order: 'CAT_NAME',
			search: { Operator: 'and', Children: [
				{ Attribute: 'HAZARD_ID', Operator: '=', LongAccessor: 'HAZARD_ID' },
				{ Attribute: 'HAZARD_TYPE', Operator: '=', StringValue: 'E' }
	]}}},
];

const phTableColumns = [
	{ Header: 'Physical Hazard', accessor: 'HAZARD_NAME' },
	{ Header: 'Category', accessor: 'CAT_NAME' }
];

const phEditColumns = [
	{ Header: 'Physical Hazard', accessor: 'HAZARD_ID', labelAccessor: 'HAZARD_NAME', type: 'select',
		options: { value: 'HAZARD_ID', label: 'HAZARD_NAME', entity: 'REUSE.HAZARD_SELECT_VW', order: 'HAZARD_NAME',
			search: { Attribute: 'HAZARD_TYPE', Operator: '=', StringValue: 'P' }
	}},
	{ Header: 'Category', accessor: 'HH_ID', labelAccessor: 'CAT_NAME', type: 'select',
		options: { value: 'HH_ID', label: 'CAT_NAME', entity: 'REUSE.HAZARD_CAT_SELECT_VW', order: 'CAT_NAME',
			search: { Operator: 'and', Children: [
				{ Attribute: 'HAZARD_ID', Operator: '=', LongAccessor: 'HAZARD_ID' },
				{ Attribute: 'HAZARD_TYPE', Operator: '=', StringValue: 'P' }
	]}}},
];

const oshaColumns = [
	{ Header: 'OSHA listed', accessor: 'chem_safety.OSHA_FLAG', type: 'checkbox', row: 0, col: 0 },
	{ Header: '29 CFR § 1910.', accessor: 'chem_safety.FEDOSHA_SEC', row: 0, col: 1 },
	{ Header: 'EPA', accessor: 'chem_safety_ghs_input.EPA', type: 'select', row: 0, col: 2,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.CHEM_SAFETY_STATEMENT', order: 'STATEMENT_CODE',
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: statementTypeMap.EPA },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
			]}}},
	{ Header: 'Cal OSHA listed', accessor: 'chem_safety.CALOSHA_FLAG', type: 'checkbox', row: 1, col: 0 },
	{ Header: '8 CCR §', accessors: ['chem_safety.CALOSHA_SEC','chem_safety.CALOSHA_SEC2'], row: 1, col: 1 },
	{ Header: 'IARC', accessor: 'chem_safety_ghs_input.IARC', type: 'select', row: 1, col: 2,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.CHEM_SAFETY_STATEMENT', order: 'STATEMENT_CODE',
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: statementTypeMap.IARC },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
			]}}},
	{ Header: 'Prop 65 Carcinogen', accessor: 'chem_safety.CARCI_65', type: 'checkbox', row: 2, col: 0 },
	{ Header: 'NIOSH', accessor: 'chem_safety_ghs_input.NIOSH', type: 'select', row: 2, col: 2,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.CHEM_SAFETY_STATEMENT', order: 'STATEMENT_CODE',
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: statementTypeMap.NIOSH },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
			]}}},
	{ Header: 'ACGIH', accessor: 'chem_safety_ghs_input.ACGIH', type: 'select', row: 3, col: 1,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.CHEM_SAFETY_STATEMENT', order: 'STATEMENT_CODE',
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: statementTypeMap.ACGIH },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
			]}}},
	{ Header: 'NTP', accessor: 'chem_safety_ghs_input.NTP', type: 'select', row: 3, col: 2,
		options: { value: 'STATEMENT_ID', label: 'STATEMENT_CODE', entity: 'REUSE.CHEM_SAFETY_STATEMENT', order: 'STATEMENT_CODE',
			search: { Operator: 'and', Children: [
				{ Attribute: 'TYPE_CODE', Operator: '=', LongValue: statementTypeMap.NTP },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
			]}}}
];

const specialColumns = [
	{ Header: 'Prop 65 Dev. Toxin', accessor: 'chem_safety.DEV_65', type: 'checkbox', row: 0, col: 0 },
	{ Header: 'Male', accessor: 'chem_safety.REPRO_M', type: 'checkbox', row: 0, col: 1 },
	{ Header: 'Female', accessor: 'chem_safety.REPRO_F', type: 'checkbox', row: 0, col: 2 },
	{ Header: 'DEA #', accessor: 'chem_safety.DEA_NUM', row: 0, col: 3 },
	{ Header: 'Controlled Substance <span style="color: red;">Schedule</span>', 
		accessor: 'chem_safety.SUBSTANCE_SCHED', type: 'select', row: 0, col: 4,
		options: [{ value: null, label: 'Select...' },{ value: 'I', label: 'I' },{ value: 'II', label: 'II' },
			{ value: 'III', label: 'III' },{ value: 'IV', label: 'IV' },{ value: 'V', label: 'V' }]},
	{ Header: 'Acutely Hazardous', accessor: 'chem_safety.ACUTE_H_FLAG', type: 'checkbox', row: 1, col: 0 },
	{ Header: 'P', accessor: 'chem_safety.P_CODE', row: 1, col: 1 },
	{ Header: 'Federal Precursor Chemical <span style="color: red;">List</span>', accessor: 'chem_safety.FED_PRECURSOR',
		options: [{ value: null, label: 'Select...' },{ value: 'I', label: 'I' },{ value: 'II', label: 'II' }],
			subscript: '(21 CFR §1310.02)', type: 'select', row: 1, col: 2 },
	{ Header: 'Threshold (kg)', accessor: 'chem_safety.LIST_TRESH', row: 1, col: 3 },
	{ Header: 'Cal DOJ Precursor Chemical HSC 11100(a)', accessor: 'chem_safety.CAL_PRECURSOR', row: 1, col: 4 },
	{ Header: 'CA Extremely Hazardous', accessor: 'chem_safety.EXTREM_H_FLAG', type: 'checkbox', row: 2, col: 0 },
	{ Header: 'Hazardous Air Pollutant', accessor: 'chem_safety.HAP', type: 'checkbox', row: 2, col: 1 },
	{ Header: 'CAA Urban Air Toxics Strategy Pollutant', accessor: 'chem_safety.CAA_URBAN_AIR', type: 'checkbox', row: 2, col: 2 },
	{ Header: 'CWC Schedule', accessor: 'chem_safety.CWC_SCHED', type: 'select', row: 2, col: 3,
		options: [{ value: null, label: 'Select...' },{ value: '1A', label: '1A' },{ value: '1B', label: '1B' },
			{ value: '2A', label: '2A' },{ value: '2B', label: '2B' },{ value: '3A', label: '3A' },{ value: '3B', label: '3B' }]}
];

const toxicColumns = [
	{ Header: 'Toxic Release Inventory (otherwise used category) (lbs)', accessor: 'TRI_REPORT_THRESHOLD', 
		row: 0, col: 0, colwidth: 12, labelColWidth: 9, valueColWidth: 3 },
	{ Header: 'TRI Symbol', accessor: 'TRI_SYMBOL', type: 'select', row: 1, col: 0,
		options: [{ value: null, label: 'Select...' },{ value: '#', label: '#' },{ value: '!', label: '!' },
		{ value: '+', label: '+' },{ value: '$', label: '$' },{ value: 'c', label: 'c' }]},
	{ Header: 'Category', accessor: 'TRI_C', type: 'select', row: 1, col: 1,
		options: { value: 'CODE_ID', label: 'CODE_NAME', entity: 'REUSE.TRI_CODES_SELECT_VW', order: 'CODE_ID' }},
	{ Header: 'Total Disposal/Releases for Dataset (YYYY)', accessor: 'TRI_DATASET', row: 2, col: 0 },
	{ Header: 'US (lbs)', accessor: 'TRI_US', row: 2, col: 1 },
	{ Header: 'Region 9 (lbs)', accessor: 'TRI_9', row: 3, col: 0 },
	{ Header: 'CA (lbs)', accessor: 'TRI_CA', row: 3, col: 1 },
	{ Header: 'Note', accessor: 'TRI_NOTE', type: 'textarea', row: 4, col: 0, colwidth: 12, labelColWidth: 1, valueColWidth: 11 },
	{ Header: 'URL', accessor: 'TRI_URL', type: 'textarea', row: 5, col: 0, colwidth: 12, labelColWidth: 1, valueColWidth: 11 }
];

const rmpColumns = [
	{ Header: 'CAA 112(r) TQ (lbs)', accessor: 'chem_safety.RMP1', row: 0, col: 0 },
	{ Header: 'CalARP TQ (lbs)', accessor: 'chem_safety.RMP3', row: 0, col: 1 },
	{ Header: 'Non-molten TQ (lbs)', accessor: 'chem_safety.RMP4', row: 0, col: 2 },
	{ Header: 'OSHA highly hazardous TQ (lbs)', accessor: 'chem_safety.RMP2', row: 1, col: 0 },
	{ Header: 'TPQ §302 (lbs)', accessor: 'chem_safety.TPQ', row: 1, col: 1 },
	{ Header: 'TPQ §302 (lbs)<br /><span style="font-size: 12px;">if not in molten form or in solution, and not a fine powder (&lt;100 μm dia.)</span>',
		accessor: 'chem_safety.TPQ2', row: 1, col: 2 },
	{ Header: 'Lachrymator', accessor: 'chem_safety.LACRIMATOR', type: 'checkbox', row: 2, col: 0 },
	{ Header: 'Readily Absorbed Through Skin', accessor: 'chem_safety.SKIN_ABSORB', type: 'checkbox', row: 2, col: 1 },
	{ Header: 'Vesicant', accessor: 'chem_safety.VESICANT', type: 'checkbox', row: 2, col: 2 },
	{ Header: 'Unpleasant Odor', accessor: 'chem_safety.UNPLEASANT_ODOR', type: 'checkbox', row: 3, col: 0 },
	{ Header: 'Stench', accessor: 'chem_safety.STENCH', type: 'checkbox', row: 3, col: 1 },
	{ Header: 'Rubefacient', accessor: 'chem_safety.RUBEFACIANT', type: 'checkbox', row: 3, col: 2 },
	{ Header: 'Photosensitizer', accessor: 'chem_safety.PHOTOSENSITIZER', type: 'checkbox', row: 4, col: 0 },
	{ Header: 'Endocrine Disruptor', accessor: 'chem_safety.ENDOCRINE_DES', type: 'checkbox', row: 4, col: 1 },
	{ Header: 'Argyria', accessor: 'chem_safety.ARGYRIA', type: 'checkbox', row: 4, col: 2 },
	{ Header: 'PHS', accessor: 'chem_safety.ANIMAL_TUMOR', type: 'checkbox', row: 5, col: 0, colwidth: 12, labelColWidth: 1, valueColWidth: 11,
		label: 'Significant tumor incidence in animals at doses: • inhalation (< 10 mg/m3 for significant portion of lifetime) ' +
		'• dermal (< 300 ppm per week) • oral (< 50 ppm per day)' }
];

const toxicInfoColumns = [
	{ Header: '', accessor: 'chem_safety.TOXIC_INFO', type: 'editor', colwidth: 12, labelColWidth: 0, valueColWidth: 12 }
];

const usageMiscColumns = [
	{ Header: '', accessor: 'chem_safety.USAGE_MISC_INFO', type: 'editor', colwidth: 12, labelColWidth: 0, valueColWidth: 12 }
];

const stabReactColumns = [
	{ Header: 'Water Reactive', accessor: 'chem_safety.WATER_REACTIVE', type: 'checkbox', row: 0, col: 0 },
	{ Header: 'May Form Explosive Peroxides', accessor: 'chem_safety.EXPLOS_PEROXIDES', type: 'checkbox', row: 0, col: 1 },
	{ Header: '', accessor: 'chem_safety.STAB_REACT', type: 'editor', row: 1, col: 0, colwidth: 12, labelColWidth: 0, valueColWidth: 12 }
];

const intlStdColumns = [
	{ Header: 'Select Standard', accessor: 'chem_i_standard_select.STANDARD_ID', type: 'select', row: 0, col: 0,
		options: { value: 'STANDARD_ID', label: 'STANDARD_NAME', entity: 'REUSE.INTERNATIONAL_STANDARD', order: 'STANDARD_ID',
			search: { Attribute: 'DELETE_FLAG', Operator: 'is null' }}},
	{ Header: 'Status', accessor: 'chem_i_standard_select.ACTIVE_FLAG', type: 'select', row: 0, col: 1,
		options: [{ value: null, label: 'Select...' },{ value: 'Y', label: 'Active' },{ value: 'N', label: 'Deleted' }]},
];

const intlStdTextColumns = [
	{ Header: '', accessor: 'chem_i_standard.I_STANDARD', type: 'editor', colwidth: 12, labelColWidth: 0, valueColWidth: 12 }
];

const canadaGHSColumns = [
	{ Header: '', accessor: 'chem_safety_ghs_input.CANADA_ISTD_A', row: 0, col: 0,
		Cell: props => props.parent.renderCanadianSafetyPictogram(props, 'A') },
	{ Header: '', accessor: 'chem_safety_ghs_input.CANADA_ISTD_B1', row: 1, col: 0,
		Cell: props => props.parent.renderCanadianSafetyPictogram(props, 'B1') },
	{ Header: '', accessor: 'chem_safety_ghs_input.CANADA_ISTD_B2', row: 2, col: 0,
		Cell: props => props.parent.renderCanadianSafetyPictogram(props, 'B2') },
	{ Header: '', accessor: 'chem_safety_ghs_input.CANADA_ISTD_B3', row: 3, col: 0,
		Cell: props => props.parent.renderCanadianSafetyPictogram(props, 'B3') },
	{ Header: '', accessor: 'chem_safety_ghs_input.CANADA_ISTD_B4', row: 0, col: 1,
		Cell: props => props.parent.renderCanadianSafetyPictogram(props, 'B4') },
	{ Header: '', accessor: 'chem_safety_ghs_input.CANADA_ISTD_B5', row: 1, col: 1,
		Cell: props => props.parent.renderCanadianSafetyPictogram(props, 'B5') },
	{ Header: '', accessor: 'chem_safety_ghs_input.CANADA_ISTD_B6', row: 2, col: 1,
		Cell: props => props.parent.renderCanadianSafetyPictogram(props, 'B6') },
	{ Header: '', accessor: 'chem_safety_ghs_input.CANADA_ISTD_C', row: 3, col: 1,
		Cell: props => props.parent.renderCanadianSafetyPictogram(props, 'C') },
	{ Header: '', accessor: 'chem_safety_ghs_input.CANADA_ISTD_D1A', row: 0, col: 2,
		Cell: props => props.parent.renderCanadianSafetyPictogram(props, 'D1A') },
	{ Header: '', accessor: 'chem_safety_ghs_input.CANADA_ISTD_D1B', row: 1, col: 2,
		Cell: props => props.parent.renderCanadianSafetyPictogram(props, 'D1B') },
	{ Header: '', accessor: 'chem_safety_ghs_input.CANADA_ISTD_D2A', row: 2, col: 2,
		Cell: props => props.parent.renderCanadianSafetyPictogram(props, 'D2A') },
	{ Header: '', accessor: 'chem_safety_ghs_input.CANADA_ISTD_D2B', row: 3, col: 2,
		Cell: props => props.parent.renderCanadianSafetyPictogram(props, 'D2B') },
	{ Header: '', accessor: 'chem_safety_ghs_input.CANADA_ISTD_E', row: 1, col: 3,
		Cell: props => props.parent.renderCanadianSafetyPictogram(props, 'E') },
	{ Header: '', accessor: 'chem_safety_ghs_input.CANADA_ISTD_F', row: 2, col: 3,
		Cell: props => props.parent.renderCanadianSafetyPictogram(props, 'F') }
];

const echaColumns = [
	{ Header: 'Status', accessor: 'chem_safety_ghs_input.EUROPE_SVHC', type: 'select', row: 0, col: 0,
		options: [{ value: null, label: 'Select...' },
		{ value: statementIDMap.EUROPE_SVHC_AUTH, label: 'Authorized'},
		{ value: statementIDMap.EUROPE_SVHC_CAND, label: 'Candidate' }]},
	{ Header: '', accessor: 'chem_safety_ghs_input.EUROPE_57A', type: 'checkbox', row: 0, col: 1,
		value: statementIDMap.EUROPE_57A, label: 'article 57 a - carcinogenic' },
	{ Header: '', accessor: 'chem_safety_ghs_input.EUROPE_57B', type: 'checkbox', row: 1, col: 1,
		value: statementIDMap.EUROPE_57B, label: 'article 57 b - mutagenic' },
	{ Header: '', accessor: 'chem_safety_ghs_input.EUROPE_57C', type: 'checkbox', row: 0, col: 2,
		value: statementIDMap.EUROPE_57C, label: 'article 57 c - reproductive' },
	{ Header: '', accessor: 'chem_safety_ghs_input.EUROPE_57D', type: 'checkbox', row: 1, col: 2,
		value: statementIDMap.EUROPE_57D, label: 'article 57 d - PBT' },
	{ Header: '', accessor: 'chem_safety_ghs_input.EUROPE_57E', type: 'checkbox', row: 0, col: 3,
		value: statementIDMap.EUROPE_57E, label: 'article 57 e - vPvB' },
	{ Header: '', accessor: 'chem_safety_ghs_input.EUROPE_57F', type: 'checkbox', row: 1, col: 3,
		value: statementIDMap.EUROPE_57F, label: 'article 57 f - serious effects' },
	{ Header: 'Inclusion Date', accessor: 'chem_i_standard_europe.INCLUSION_DATE', type: 'date', row: 2, col: 0 },
	{ Header: 'Sunset Date', accessor: 'chem_i_standard_europe.SUNSET_DATE', type: 'date', row: 2, col: 1 },	
];

export default withChemicalDefaultRoute(Chemical);
